window.NRK = {
  "meta": {
    "name": "NRK Event Planner Data",
    "sourceWorkbook": "NRK_Event_Planner_Decision_Engine_v4_Normalized.xlsx",
    "generatedAt": "2026-07-04T09:56:34",
    "scoreLegend": {
      "1": "Best Fit",
      "2": "Alternative",
      "blank": "Hide / Not Recommended"
    }
  },
  "settings": [
    {
      "setting": "Primary website path",
      "value": "/pages/plan-your-event",
      "notes": "New Shopify Debut page"
    },
    {
      "setting": "Direct quote path",
      "value": "Existing Hulk Form",
      "notes": "Keep current flow for clients who know what they want"
    },
    {
      "setting": "Planner output",
      "value": "2 package options + menu reco + add-ons",
      "notes": "No full PDFs on website"
    },
    {
      "setting": "Proposal approach",
      "value": "Recommended dish first + alternative selections",
      "notes": "Keep client flexibility without overwhelming upfront"
    },
    {
      "setting": "VAT",
      "value": "12%",
      "notes": "Rates exclusive unless otherwise stated"
    },
    {
      "setting": "Service Charge",
      "value": "5%",
      "notes": "Rates exclusive unless otherwise stated"
    },
    {
      "setting": "Full Service Standard Duration",
      "value": "4 hours",
      "notes": "Excluding ingress/egress"
    },
    {
      "setting": "Rustic Stations Duration",
      "value": "3-4 hours or until supplies consumed",
      "notes": "Excluding ingress/egress"
    },
    {
      "setting": "Location Logic",
      "value": "Use Location_Rules as pre-qualification before package scoring",
      "notes": "Added for planner v1"
    }
  ],
  "eventTypes": [
    {
      "eventThemeID": "EV_BIRTHDAYS_SOCIAL",
      "eventTheme": "Birthdays & Social Celebrations",
      "exampleEvents": "Birthdays, family gatherings and milestone celebrations",
      "primaryServiceRoute": "Full Service Catering or Rustic Stations",
      "secondaryRouteAddOns": "Party Trays for small/simple events; Kiddie Buffet; Styling; Mini Graze; Beverage Tub",
      "defaultBestFit": "FC_RUSTIC_B",
      "defaultAlternative": "FC_SIGNATURE",
      "assistantTone": "Warm, friendly and consultative"
    },
    {
      "eventThemeID": "EV_CHILDRENS_PARTY",
      "eventTheme": "Children's Parties",
      "exampleEvents": "Children's birthdays, baptisms and family celebrations",
      "primaryServiceRoute": "Full Service Catering",
      "secondaryRouteAddOns": "Kiddie Buffet; Mini Graze; Beverage Tub; Styling",
      "defaultBestFit": "FC_RUSTIC_A",
      "defaultAlternative": "ST_A",
      "assistantTone": "Warm, cheerful and family-friendly"
    },
    {
      "eventThemeID": "EV_CORPORATE",
      "eventTheme": "Corporate Events",
      "exampleEvents": "Meetings, seminars, office lunches and company functions",
      "primaryServiceRoute": "Full Service Catering",
      "secondaryRouteAddOns": "Rustic Lite for short/large format; Rustic Stations; Coffee; Beverage Stations",
      "defaultBestFit": "FC_SIGNATURE",
      "defaultAlternative": "ST_B",
      "assistantTone": "Professional, efficient and solutions-focused"
    },
    {
      "eventThemeID": "EV_COCKTAIL_NETWORKING",
      "eventTheme": "Cocktail & Networking Events",
      "exampleEvents": "Launches, receptions and standing cocktail events",
      "primaryServiceRoute": "Rustic Stations",
      "secondaryRouteAddOns": "Signature Graze; Rustic Cocktails; Beverage Stations; Cocktail Tables",
      "defaultBestFit": "RS_COCKTAILS",
      "defaultAlternative": "RS_SIGNATURE_GRAZE",
      "assistantTone": "Polished and businesslike"
    },
    {
      "eventThemeID": "EV_WEDDINGS",
      "eventTheme": "Weddings",
      "exampleEvents": "Wedding receptions, intimate celebrations, and rehearsal dinners",
      "primaryServiceRoute": "Full Service Catering",
      "secondaryRouteAddOns": "Rustic Cocktails; Signature Graze; Long Table Styling; Beverage Stations",
      "defaultBestFit": "FC_SIGNATURE",
      "defaultAlternative": "FC_RUSTIC_B",
      "assistantTone": "Premium, reassuring and detail-oriented"
    }
  ],
  "packages": [
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/EBE5D52E-F2F7-40C2-834B-0650FAA1D857.jpg?v=1784379469",
      "serviceType": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "bestFor": "Kiddie parties, family celebrations",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "4 hours",
      "pricingBasis": "Per head",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/150CF881-4CB6-4EFA-8D95-E966073F9952.jpg?v=1781316901",
      "serviceType": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "bestFor": "Socials, weddings, family/corporate dining",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "4 hours",
      "pricingBasis": "Per head",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/AAA_5903.jpg?v=1741508987",
      "serviceType": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "bestFor": "Premium socials, weddings, corporate entertaining",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "4 hours",
      "pricingBasis": "Per head",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/IMG_4970.jpg?v=1780113119",
      "serviceType": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "bestFor": "Premium / elevated full meal",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "4 hours",
      "pricingBasis": "Per head",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/742CCA88-BEAB-416E-B8A8-00CC58F4F650.jpg?v=1781316900",
      "serviceType": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "bestFor": "Simpler crowd-favorite buffet",
      "minPaxRegular": 50,
      "minPaxPeakDec": 70,
      "serviceHours": "4 hours",
      "pricingBasis": "Per head",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "ST_B",
      "packageName": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/7DDFCAB5-B1A7-4118-9BA0-3607AF78ACE4.jpg?v=1784446217",
      "serviceType": "Full-Service Catering includes a complete banquet setup with guest tables and chairs",
      "bestFor": "Simple buffet with pork roast",
      "minPaxRegular": 50,
      "minPaxPeakDec": 70,
      "serviceHours": "4 hours",
      "pricingBasis": "Per head",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "image":"https://cdn.shopify.com/s/files/1/0262/5457/3648/files/Ayala.jpg?v=1715615059",
      "serviceType": "Assisted stand-alone food station; guest tables and chairs available as an upgrade",
      "bestFor": "Relaxed celebrations and kiddie parties",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "3–4 hours or until consumed",
      "pricingBasis": "Fixed tier",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "image":"https://cdn.shopify.com/s/files/1/0262/5457/3648/files/E9E812A7-CF50-45C3-B508-4FBB1F183AF7.jpg?v=1781326426",
      "serviceType": "Assisted stand-alone food station; guest tables and chairs available as an upgrade",
      "bestFor": "Socials, corporate entertaining, networking, weddings",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "3–4 hours or until consumed",
      "pricingBasis": "Fixed tier",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "image":"https://cdn.shopify.com/s/files/1/0262/5457/3648/files/AAA_5949.jpg?v=1677907247",
      "serviceType": "Assisted stand-alone food station; guest tables and chairs available as an upgrade",
      "bestFor": "Light refreshments, socials, corporate entertainings, networkings, weddings",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "3–4 hours or until consumed",
      "pricingBasis": "Fixed tier",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/84BB098F-BFA7-41A8-85EA-86AE7EE76C05.jpg?v=1781326426",
      "serviceType": "Assisted stand-alone food station; guest tables and chairs available as an upgrade",
      "bestFor": "More abundant grazing with pasta and bites",
      "minPaxRegular": 30,
      "minPaxPeakDec": 50,
      "serviceHours": "3–4 hours or until consumed",
      "pricingBasis": "Fixed tier",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/3A81487D-366A-45C9-BFE0-B97A155FC525.jpg?v=1784378577",
      "serviceType": "Assisted stand-alone food station; guest tables and chairs available as an upgrade",
      "bestFor": "Short-format events, brunch, corporate socials, weddings",
      "minPaxRegular": 100,
      "minPaxPeakDec": 100,
      "serviceHours": "3–4 hours or until consumed",
      "pricingBasis": "Fixed tier",
      "vATSCNote": "Exclusive of 12% VAT + 5% SC",
      "websiteExposure": "Recommend only"
    }
  ],
  "pricingMatrix": [
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "tierLabel": "30-40 pax",
      "paxFrom": 30,
      "paxTo": 40,
      "basePrice": 1150,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "tierLabel": "50-90 pax",
      "paxFrom": 50,
      "paxTo": 90,
      "basePrice": 1030,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 1000,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "tierLabel": "30-40 pax",
      "paxFrom": 30,
      "paxTo": 40,
      "basePrice": 1250,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "tierLabel": "50-90 pax",
      "paxFrom": 50,
      "paxTo": 90,
      "basePrice": 1170,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 1140,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "tierLabel": "30-40 pax",
      "paxFrom": 30,
      "paxTo": 40,
      "basePrice": 1380,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "tierLabel": "50-90 pax",
      "paxFrom": 50,
      "paxTo": 90,
      "basePrice": 1285,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 1260,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "tierLabel": "30-40 pax",
      "paxFrom": 30,
      "paxTo": 40,
      "basePrice": 1920,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "tierLabel": "50-90 pax",
      "paxFrom": 50,
      "paxTo": 90,
      "basePrice": 1850,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "tierLabel": "100+ pax",
      "paxFrom": 100,
      "paxTo": 9999,
      "basePrice": 1800,
      "priceType": "Per Head",
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "tierLabel": "All regular tiers",
      "paxFrom": "50-90 pax",
      "paxTo": 90,
      "basePrice": 910,
      "priceType": "Per Head",
      "notes": "100+ may get P20/head discount per PDF"
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "tierLabel": "100+ pax",
      "paxFrom": 100,
      "paxTo": 9999,
      "basePrice": 890,
      "priceType": "Per Head",
      "notes": "Starting rate; final pricing and arrangements above 100 guests are subject to confirmation."
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "tierLabel": "50-90 pax",
      "paxFrom": 50,
      "paxTo": 90,
      "basePrice": 1010,
      "priceType": "Per Head",
      "notes": "100+ may get P20/head discount per PDF"
    },
     {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "tierLabel": "100+ pax",
      "paxFrom": 100,
      "paxTo": 9999,
      "basePrice": 990,
      "priceType": "Per Head",
      "notes": "Starting rate; final pricing and arrangements above 100 guests are subject to confirmation."
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "tierLabel": "30 pax",
      "paxFrom": 30,
      "paxTo": 30,
      "basePrice": 32600,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "tierLabel": "50 pax",
      "paxFrom": 50,
      "paxTo": 50,
      "basePrice": 47500,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 93000,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "tierLabel": "30 pax",
      "paxFrom": 30,
      "paxTo": 30,
      "basePrice": 38100,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "tierLabel": "50 pax",
      "paxFrom": 50,
      "paxTo": 50,
      "basePrice": 54100,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 107700,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "tierLabel": "30 pax",
      "paxFrom": 30,
      "paxTo": 30,
      "basePrice": 34250,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "tierLabel": "50 pax",
      "paxFrom": 50,
      "paxTo": 50,
      "basePrice": 48000,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 95000,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "tierLabel": "30 pax",
      "paxFrom": 30,
      "paxTo": 30,
      "basePrice": 41500,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "tierLabel": "50 pax",
      "paxFrom": 50,
      "paxTo": 50,
      "basePrice": 59250,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 115000,
      "priceType": "Fixed",
      "notes": null
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "tierLabel": "100 pax",
      "paxFrom": 100,
      "paxTo": 100,
      "basePrice": 75000,
      "priceType": "Fixed",
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "tierLabel": "150 pax",
      "paxFrom": 150,
      "paxTo": 150,
      "basePrice": 107500,
      "priceType": "Fixed",
      "notes": "Minimum 100 guests"
    }
  ],
  "packageRules": [
    {
      "ruleID": "RULE_RB_SLIDER_30",
      "packageID": "RS_BITES",
      "category": "Slider or Crostini",
      "paxCondition": "30-50 pax",
      "clientChoiceAllowed": "Choose 1",
      "assistantDisplay": "Show recommended 1",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_RB_SLIDER_100",
      "packageID": "RS_BITES",
      "category": "Slider or Crostini",
      "paxCondition": "100 pax",
      "clientChoiceAllowed": "Choose up to 2",
      "assistantDisplay": "Show recommended 2",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_RB_DESSERT_30",
      "packageID": "RS_BITES",
      "category": "Dessert",
      "paxCondition": "30-50 pax",
      "clientChoiceAllowed": "Choose 1",
      "assistantDisplay": "Show recommended 1",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_RB_DESSERT_100",
      "packageID": "RS_BITES",
      "category": "Dessert",
      "paxCondition": "100 pax",
      "clientChoiceAllowed": "Choose up to 2",
      "assistantDisplay": "Show recommended 2",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_RC_CANAPE",
      "packageID": "RS_COCKTAILS",
      "category": "Canape & Crostini",
      "paxCondition": "All pax",
      "clientChoiceAllowed": "Choose 4",
      "assistantDisplay": "Show curated 4",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_RC_DESSERT_30",
      "packageID": "RS_COCKTAILS",
      "category": "Dessert",
      "paxCondition": "30/50 pax",
      "clientChoiceAllowed": "Choose 1",
      "assistantDisplay": "Show recommended 1",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_RC_DESSERT_100",
      "packageID": "RS_COCKTAILS",
      "category": "Dessert",
      "paxCondition": "100 pax",
      "clientChoiceAllowed": "Choose 1-2",
      "assistantDisplay": "Show recommended 2 if budget allows",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_FULL_APP",
      "packageID": "FC_SIGNATURE;FC_FEAST",
      "category": "Appetizers",
      "paxCondition": "All pax",
      "clientChoiceAllowed": "Choose 2",
      "assistantDisplay": "Show recommended 2",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_FULL_DESSERT_30",
      "packageID": "FC_RUSTIC_B;FC_SIGNATURE",
      "category": "Dessert",
      "paxCondition": "30-50 pax",
      "clientChoiceAllowed": "Choose 1",
      "assistantDisplay": "Show recommended 1",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_FULL_DESSERT_100",
      "packageID": "FC_RUSTIC_B;FC_SIGNATURE",
      "category": "Dessert",
      "paxCondition": "100 pax",
      "clientChoiceAllowed": "Choose up to 2",
      "assistantDisplay": "Show recommended 2 if appropriate",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": null
    },
    {
      "ruleID": "RULE_PASTA",
      "packageID": "Multiple",
      "category": "Pasta",
      "paxCondition": "All pax",
      "clientChoiceAllowed": "Choose 1",
      "assistantDisplay": "Show 1 recommended pasta",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": "Truffle options +P30/head"
    },
    {
      "ruleID": "RULE_STANDARD_DESSERT",
      "packageID": "ST_A;ST_B",
      "category": "Dessert",
      "paxCondition": "All pax",
      "clientChoiceAllowed": "Choose 1",
      "assistantDisplay": "Show 1 recommended dessert",
      "proposalDisplay": "Show recommended + alternatives",
      "notes": "Peach & Mango Parfait indoor only"
    }
  ],
  "packageScoring": [
    {
      "eventTheme": "Birthdays & Social Celebrations",
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "conditionUseWhen": "Family and social celebrations",
      "reason": "A generous buffet of crowd favorites for family celebrations"
    },
    {
      "eventTheme": "Birthdays & Social Celebrations",
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 30,
      "paxTo": 99,
      "conditionUseWhen": "A little more varied selection",
      "reason": "An upgraded buffet of crowd favorites with an added selection of appetizers for family celebrations"
    },
    {
      "eventTheme": "Birthdays & Social Celebrations",
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 100,
      "paxTo": null,
      "conditionUseWhen": "A straightforward buffet works best for a larger gathering",
      "reason": "A simpler buffet selection that covers all the crowd favorites"
    },
    {
      "eventTheme": "Children's Parties",
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu B",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 30,
      "paxTo": 40,
      "conditionUseWhen": "A complete buffet is preferred for a smaller celebration",
      "reason": "A generous family-friendly buffet for an intimate children’s party"
    },
    {
      "eventTheme": "Children's Parties",
      "packageID": "RS_BITES",
      "packageName": "Natalia's Rustic Bites",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 30,
      "paxTo": 40,
      "conditionUseWhen": "A casual food station is preferred",
      "reason": "A fun selection of easy-to-eat bites for children and adults"
    },
    {
      "eventTheme": "Children's Parties",
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 50,
      "paxTo": 99,
      "conditionUseWhen": "A complete family-friendly buffet is preferred",
      "reason": "A family-friendly mix of finger foods and hearty mains"
    },
    {
      "eventTheme": "Children's Parties",
      "packageID": "RS_BITES",
      "packageName": "Natalia's Rustic Bites",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 50,
      "paxTo": 99,
      "conditionUseWhen": "A casual food station is preferred",
      "reason": "A fun selection of easy-to-eat bites for children and adults"
    },
    {
      "eventTheme": "Children's Parties",
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "A practical buffet is needed for a larger celebration",
      "reason": "A crowd-friendly buffet that works well for larger children’s parties"
    },
    {
      "eventTheme": "Children's Parties",
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "An interactive food station is preferred",
      "reason": "A family-friendly mix of finger foods and hearty mains"
    },
    {
      "eventTheme": "Corporate Events",
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 30,
      "paxTo": 40,
      "conditionUseWhen": "Corporate lunches, dinners, and smaller company celebrations",
      "reason": "An upgraded buffet of crowd favorites with an added selection of appetizers for corporate events"
    },
    {
      "eventTheme": "Corporate Events",
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 30,
      "paxTo": 40,
      "conditionUseWhen": "A simpler buffet is preferred for a smaller gathering",
      "reason": "A premium alternative for small to mid-sized corporate events"
    },
    {
      "eventTheme": "Corporate Events",
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 50,
      "paxTo": 99,
      "conditionUseWhen": "A generous buffet is preferred for a mid-sized gathering",
      "reason": "A premium alternative for small to mid-sized corporate events"
    },
    {
      "eventTheme": "Corporate Events",
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 50,
      "paxTo": 99,
      "conditionUseWhen": "A more practical buffet is preferred",
      "reason": "A practical buffet selection for mid-sized corporate gatherings"
    },
    {
      "eventTheme": "Corporate Events",
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "A complete and practical buffet is needed for a larger gathering",
      "reason": "A crowd-friendly buffet that works well for larger corporate events"
    },
    {
      "eventTheme": "Corporate Events",
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "A more budget-friendly buffet is preferred",
      "reason": "A practical buffet selection for larger corporate gatherings"
    },
    {
      "eventTheme": "Cocktail & Networking Events",
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 30,
      "paxTo": 99,
      "conditionUseWhen": "Cocktail-style events with 30–99 guests",
      "reason": "Ideal for events where easy-to-eat bites work best"
    },
    {
      "eventTheme": "Cocktail & Networking Events",
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 30,
      "paxTo": 99,
      "conditionUseWhen": "A more generous grazing spread is preferred",
      "reason": "A generous grazing spread for social and networking events"
    },
    {
      "eventTheme": "Cocktail & Networking Events",
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "A filling station is needed for 100 guests or more",
      "reason": "A simple yet filling selection for town halls and larger gatherings"
    },
    {
      "eventTheme": "Cocktail & Networking Events",
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "A grazing-style setup is preferred for a larger event",
      "reason": "A lighter grazing spread that works well for larger gatherings"
    },
    {
      "eventTheme": "Weddings",
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 30,
      "paxTo": 99,
      "conditionUseWhen": "Wedding reception with 30–99 guests",
      "reason": "An upgraded buffet of crowd favorites with an added selection of appetizers for wedding receptions"
    },
    {
      "eventTheme": "Weddings",
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 30,
      "paxTo": 99,
      "conditionUseWhen": "A more elevated wedding menu is preferred",
      "reason": "Our most generous full-service menu for an intimate wedding"
    },
    {
      "eventTheme": "Weddings",
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "score": 1,
      "recommendationLabel": "Best Fit",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "Wedding reception with 100 guests or more",
      "reason": "An upgraded buffet of crowd favorites with an added selection of appetizers for wedding receptions"
    },
    {
      "eventTheme": "Weddings",
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "score": 2,
      "recommendationLabel": "Alternative",
      "paxFrom": 100,
      "paxTo": 300,
      "conditionUseWhen": "A more practical menu is preferred for a larger wedding",
      "reason": "A premium alternative offering the best value for larger weddings"
    }
   ],
  "partyTrayRecommendations": [
    {
      "id": "PT_BEEF_SALPICAO",
      "name": "Signature Beef Salpicao",
      "description": "Our signature crowd favorite and a true hero dish for any celebration.",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/products/1290527c-196d-4ec6-9c2b-560649fe288a_9402d504-b61e-4221-a73d-830235539391.png?v=1614402213",
      "url": "https://nataliasrustickitchen.com/collections/party-trays/products/kitchens-signature-beef-salpicao"
    },
    {
      "id": "PT_PORK_BELLY",
      "name": "6-Hour Slow-Roasted Pork Belly",
      "description": "Slow-roasted until tender, with perfectly crisp, crunchy skin.",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/products/391c086d-565e-4ba3-8fb4-2a66aaf5a35d_ad41d2e4-487d-47fa-96d1-378e135ce341.png?v=1614402164",
      "url": "https://nataliasrustickitchen.com/collections/party-trays/products/party-trays-pork-belly"
    },
        {
      "id": "PT_CHICKEN_KEBAB",
      "name": "Chicken Kebab with Tzatziki Dip",
      "description": "Tender, flavorful chicken kebabs paired with a cool and refreshing tzatziki dip.",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/DC421A04-412A-48C5-9AC1-E076B3633B9C.jpg?v=1766990619",
      "url": "https://nataliasrustickitchen.com/collections/party-trays/products/chicken-kebab-with-tzatziki-dip"
    },
    {
      "id": "PT_SHRIMP_CHORIZO",
      "name": "Shrimp Chorizo al Ajillo",
      "description": "Succulent shrimp and savory chorizo sautéed in fragrant olive oil and garlic.",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/ShirmpChorizo.jpg?v=1777650495",
      "url": "https://nataliasrustickitchen.com/collections/party-trays/products/gambas-y-chorizo"
    },
    {
      "id": "PT_TRUFFLE_PASTA",
      "name": "Truffle Cream Fettuccine",
      "description": "A rich and indulgent pasta in a velvety truffle cream sauce.",
      "image": "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/NRKTrufflePasta3.jpg?v=1777650207",
      "url": "https://nataliasrustickitchen.com/collections/party-trays/products/truffle-cream-fettuccine"
    }
  ],
  "packageMenus": [
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Slider",
      "rule": "Included",
      "menuID": "MENU_CHEESEBURGER_SLIDERS_WITH_BACON_CHIPS",
      "menuItem": "Cheeseburger Sliders with Bacon & Chips",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Recommended for kiddie parties"
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Main Entrees",
      "rule": "All included",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Main Entrees",
      "rule": "All included",
      "menuID": "MENU_AMERICAN_STYLE_PORK_BBQ_RIBS",
      "menuItem": "American Style Pork BBQ Ribs",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Main Entrees",
      "rule": "All included",
      "menuID": "MENU_CHICKEN_TENDERS_WITH_GLAZED_DOUGHNUT_POPPERS",
      "menuItem": "Chicken Tenders with Glazed Doughnut Poppers",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO",
      "menuItem": "Homemade Pesto",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Rice",
      "rule": "Included",
      "menuID": "MENU_STEAMED_RICE",
      "menuItem": "Steamed Rice",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Dessert",
      "rule": "Included",
      "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
      "menuItem": "Salted Gooey Brownie Tart",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Refreshments",
      "rule": "Included",
      "menuID": "MENU_PURIFIED_DRINKING_WATER",
      "menuItem": "Purified Drinking Water",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_A",
      "packageName": "Rustic Menu A",
      "category": "Refreshments",
      "rule": "Included",
      "menuID": "MENU_ICED_TEA_UNTIL_SUPPLIES_LAST",
      "menuItem": "Iced Tea until supplies last",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_RUSTIC_CAESAR_SALAD",
      "menuItem": "Rustic Caesar Salad",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_SUMMER_SALAD",
      "menuItem": "Summer Salad",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_GREEK_SALAD",
      "menuItem": "Greek Salad",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_ASIAN_SOBA_SLAW_SALAD",
      "menuItem": "Asian Soba Slaw Salad",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_KEBAB_WITH_TZATZIKI_DIP",
      "menuItem": "Chicken Kebab with Tzatziki Dip",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
      "menuItem": "Traditional Roast Chicken",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_TERIYAKI",
      "menuItem": "Chicken Teriyaki",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
      "menuItem": "Jamaican Jerk Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_INASAL",
      "menuItem": "Chicken Inasal",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
      "menuItem": "Creamy Herb Garlic Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Seafood",
      "rule": "Choose 1",
      "menuID": "MENU_SEARED_NORWEGIAN_SALMON_WITH_MUSHROOM_CREAM_SAUCE",
      "menuItem": "Seared Norwegian Salmon with Mushroom Cream Sauce",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Seafood",
      "rule": "Choose 1",
      "menuID": "MENU_SHRIMP_CHORIZO_AL_AJILLO",
      "menuItem": "Shrimp & Chorizo Al Ajillo",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_CLASSIC_U_S_ROAST_BEEF",
      "menuItem": "Classic U.S. Roast Beef",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Signature Roast",
      "rule": "Included",
      "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY_WITH_FENNEL_ROASTED_VEGETABLES_",
      "menuItem": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO",
      "menuItem": "Homemade Pesto",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_VANILLA_CR_ME_BRULEE_POTS",
      "menuItem": "Vanilla Crème Brulee Pots",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_TIRAMISU",
      "menuItem": "Tiramisu",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_LUXE_BELGIAN_CHOCOLATE_MOUSSE",
      "menuItem": "Luxe Belgian Chocolate Mousse",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_RUSTIC_B",
      "packageName": "Rustic Menu B",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
      "menuItem": "Salted Gooey Brownie Tart",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_SPANISH_MEATBALLS",
      "menuItem": "Spanish Meatballs",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS_WITH_TZATZIKI_DIP",
      "menuItem": "Mini Chicken Kebab Skewers with Tzatziki Dip",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_MINI_CHICKEN_INASAL_SKEWERS",
      "menuItem": "Mini Chicken Inasal Skewers",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_EGG_SALAD_CANAPE",
      "menuItem": "Egg Salad Canape",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_CHICKEN_SALAD_SLIDER",
      "menuItem": "Chicken Salad Slider",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_ROAST_BEEF_CROSTINI",
      "menuItem": "Roast Beef Crostini",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
      "menuItem": "Brie & Berry Jam Crostini",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_CAPRESE_CROSTINI",
      "menuItem": "Caprese Crostini",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_TUNA_TARTLET",
      "menuItem": "Tuna Tartlet",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_SMOKED_SALMON_MOUSSE_TARTLET",
      "menuItem": "Smoked Salmon Mousse Tartlet",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_DUCK_CONFIT_TARTLET",
      "menuItem": "Duck Confit Tartlet",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_DUCK_CONFIT_TARTLET_FOIE_GRAS",
      "menuItem": "Duck Confit Tartlet & Foie Gras",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_RUSTIC_CAESAR_SALAD",
      "menuItem": "Rustic Caesar Salad",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_SUMMER_SALAD",
      "menuItem": "Summer Salad",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_GREEK_SALAD",
      "menuItem": "Greek Salad",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_ASIAN_SOBA_SLAW_SALAD",
      "menuItem": "Asian Soba Slaw Salad",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_KEBAB_WITH_TZATZIKI_DIP",
      "menuItem": "Chicken Kebab with Tzatziki Dip",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
      "menuItem": "Traditional Roast Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_TERIYAKI",
      "menuItem": "Chicken Teriyaki",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
      "menuItem": "Jamaican Jerk Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_INASAL",
      "menuItem": "Chicken Inasal",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
      "menuItem": "Creamy Herb Garlic Chicken",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Seafood",
      "rule": "Choose 1",
      "menuID": "MENU_SEARED_NORWEGIAN_SALMON_WITH_MUSHROOM_CREAM_SAUCE",
      "menuItem": "Seared Norwegian Salmon with Mushroom Cream Sauce",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Seafood",
      "rule": "Choose 1",
      "menuID": "MENU_SHRIMP_CHORIZO_AL_AJILLO",
      "menuItem": "Shrimp & Chorizo Al Ajillo",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO",
      "menuItem": "Homemade Pesto",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_CLASSIC_U_S_ROAST_BEEF",
      "menuItem": "Classic U.S. Roast Beef",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Signature Roast",
      "rule": "Included",
      "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY_WITH_FENNEL_ROASTED_VEGETABLES_",
      "menuItem": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_VANILLA_CR_ME_BRULEE_POTS",
      "menuItem": "Vanilla Crème Brulee Pots",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_TIRAMISU",
      "menuItem": "Tiramisu",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_LUXE_BELGIAN_CHOCOLATE_MOUSSE",
      "menuItem": "Luxe Belgian Chocolate Mousse",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_SIGNATURE",
      "packageName": "Natalia's Signature",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
      "menuItem": "Salted Gooey Brownie Tart",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Charcuterie",
      "rule": "Included",
      "menuID": "MENU_2_KINDS_OF_ARTISANAL_CHEESE",
      "menuItem": "2 kinds of Artisanal Cheese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Charcuterie",
      "rule": "Included",
      "menuID": "MENU_2_PREMIUM_CHARCUTERIE_CUTS",
      "menuItem": "2 Premium Charcuterie Cuts",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Charcuterie",
      "rule": "Included",
      "menuID": "MENU_FRESH_BERRIES",
      "menuItem": "Fresh Berries",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Welcome Drink",
      "rule": "Included",
      "menuID": "MENU_1_ROUND_TROPICAL_SUNSHINE_FRUIT_JUICE",
      "menuItem": "1 Round Tropical Sunshine Fruit Juice",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_SPANISH_MEATBALLS",
      "menuItem": "Spanish Meatballs",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS",
      "menuItem": "Mini Chicken Kebab Skewers",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_MINI_CHICKEN_INASAL_SKEWERS",
      "menuItem": "Mini Chicken Inasal Skewers",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_EGG_SALAD_CANAPE",
      "menuItem": "Egg Salad Canape",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_CHICKEN_SALAD_SLIDER",
      "menuItem": "Chicken Salad Slider",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_ROAST_BEEF_CROSTINI",
      "menuItem": "Roast Beef Crostini",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
      "menuItem": "Brie & Berry Jam Crostini",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_CAPRESE_CROSTINI",
      "menuItem": "Caprese Crostini",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_TUNA_TARTLET",
      "menuItem": "Tuna Tartlet",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Appetizers",
      "rule": "Choose 2",
      "menuID": "MENU_PREMIUM_TARTLETS",
      "menuItem": "premium tartlets",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Soup",
      "rule": "Choose 1",
      "menuID": "MENU_ROASTED_PUMPKIN_SOUP",
      "menuItem": "Roasted Pumpkin Soup",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Soup",
      "rule": "Choose 1",
      "menuID": "MENU_POTATO_LEEK_SOUP",
      "menuItem": "Potato & Leek Soup",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Soup",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_SOUP",
      "menuItem": "Mushroom Soup",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Soup",
      "rule": "Choose 1",
      "menuID": "MENU_TOMATO_SOUP",
      "menuItem": "Tomato Soup",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_RUSTIC_CAESAR_SALAD",
      "menuItem": "Rustic Caesar Salad",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_SUMMER_SALAD",
      "menuItem": "Summer Salad",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_GREEK_SALAD",
      "menuItem": "Greek Salad",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Salad",
      "rule": "Choose 1",
      "menuID": "MENU_ASIAN_SOBA_SLAW_SALAD",
      "menuItem": "Asian Soba Slaw Salad",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_KEBAB_WITH_TZATZIKI_DIP",
      "menuItem": "Chicken Kebab with Tzatziki Dip",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
      "menuItem": "Traditional Roast Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_TERIYAKI",
      "menuItem": "Chicken Teriyaki",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
      "menuItem": "Jamaican Jerk Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_INASAL",
      "menuItem": "Chicken Inasal",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
      "menuItem": "Creamy Herb Garlic Chicken",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO",
      "menuItem": "Homemade Pesto",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Main Entrees",
      "rule": "All included",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Main Entrees",
      "rule": "All included",
      "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY",
      "menuItem": "6-hr Slow Roasted Pork Belly",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Main Entrees",
      "rule": "All included",
      "menuID": "MENU_THREE_CHEESE_BAKED_PRAWNS",
      "menuItem": "Three Cheese Baked Prawns",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Rustic Tartlets",
      "rule": "Included",
      "menuID": "MENU_FRUIT_TARTLET",
      "menuItem": "Fruit Tartlet",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "FC_FEAST",
      "packageName": "Natalia's Rustic Feast",
      "category": "Rustic Tartlets",
      "rule": "Included",
      "menuID": "MENU_CHOCOLATE_MOUSSE_TARTLET_WITH_CARDAMOM",
      "menuItem": "Chocolate Mousse Tartlet with Cardamom",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Salad",
      "rule": "Included",
      "menuID": "MENU_MESCLUN_GREENS_WITH_BALSAMIC_DRESSING",
      "menuItem": "Mesclun Greens with Balsamic Dressing",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_BRAISED_BEEF_SHORT_RIBS",
      "menuItem": "Braised Beef Short Ribs",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
      "menuItem": "Traditional Roast Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_TERIYAKI",
      "menuItem": "Chicken Teriyaki",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
      "menuItem": "Jamaican Jerk Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_INASAL",
      "menuItem": "Chicken Inasal",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CLASSIC_CHICKEN_BBQ",
      "menuItem": "Classic Chicken BBQ",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
      "menuItem": "Creamy Herb Garlic Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Fish",
      "rule": "Included",
      "menuID": "MENU_GOLDEN_CREAM_DORY_FILLET_WITH_TARTAR_SAUCE",
      "menuItem": "Golden Cream Dory Fillet with Tartar Sauce",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO",
      "menuItem": "Homemade Pesto",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Sides",
      "rule": "Included",
      "menuID": "MENU_STEAMED_RICE",
      "menuItem": "Steamed Rice",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Sides",
      "rule": "Included",
      "menuID": "MENU_HOMEMADE_MASHED_POTATOES",
      "menuItem": "Homemade Mashed Potatoes",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_LECHE_FLAN",
      "menuItem": "Leche Flan",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Peach & Mango Parfait recommended indoors only"
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_CATHEDRAL_WINDOW_JELLY",
      "menuItem": "Creamy Cathedral Window Jelly",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": "Peach & Mango Parfait recommended indoors only"
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_DOUBLE_CHOCOLATE_BELGIAN_BROWNIE_BITES",
      "menuItem": "Double Chocolate Belgian Brownie Bites",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": "Peach & Mango Parfait recommended indoors only"
    },
    {
      "packageID": "ST_A",
      "packageName": "Standard Menu A",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_PEACH_MANGO_PARFAIT",
      "menuItem": "Peach & Mango Parfait",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": "Peach & Mango Parfait recommended indoors only"
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Salad",
      "rule": "Included",
      "menuID": "MENU_MESCLUN_GREENS_WITH_BALSAMIC_DRESSING",
      "menuItem": "Mesclun Greens with Balsamic Dressing",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_BRAISED_BEEF_SHORT_RIBS",
      "menuItem": "Braised Beef Short Ribs",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Beef",
      "rule": "Choose 1",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
      "menuItem": "Traditional Roast Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_TERIYAKI",
      "menuItem": "Chicken Teriyaki",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
      "menuItem": "Jamaican Jerk Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CHICKEN_INASAL",
      "menuItem": "Chicken Inasal",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CLASSIC_CHICKEN_BBQ",
      "menuItem": "Classic Chicken BBQ",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Chicken",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
      "menuItem": "Creamy Herb Garlic Chicken",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Fish",
      "rule": "Included",
      "menuID": "MENU_GOLDEN_CREAM_DORY_FILLET_WITH_TARTAR_SAUCE",
      "menuItem": "Golden Cream Dory Fillet with Tartar Sauce",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO",
      "menuItem": "Homemade Pesto",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Signature Roast",
      "rule": "Included",
      "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY_WITH_FENNEL_ROASTED_VEGETABLES_",
      "menuItem": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_LECHE_FLAN",
      "menuItem": "Leche Flan",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMY_CATHEDRAL_WINDOW_JELLY",
      "menuItem": "Creamy Cathedral Window Jelly",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_DOUBLE_CHOCOLATE_BELGIAN_BROWNIE_BITES",
      "menuItem": "Double Chocolate Belgian Brownie Bites",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "ST_B",
      "packageName": "Standard Menu B",
      "category": "Dessert",
      "rule": "Choose 1",
      "menuID": "MENU_PEACH_MANGO_PARFAIT",
      "menuItem": "Peach & Mango Parfait",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Base Inclusions",
      "rule": "Included",
      "menuID": "MENU_CROISSANT_PETITE_PLATTER",
      "menuItem": "Croissant Petite Platter",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Base Inclusions",
      "rule": "Included",
      "menuID": "MENU_CHICKEN_TENDERS_GLAZED_DOUGHNUT_POPPERS",
      "menuItem": "Chicken Tenders & Glazed Doughnut Poppers",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Base Inclusions",
      "rule": "Included",
      "menuID": "MENU_MINI_HASH_BROWNS",
      "menuItem": "Mini Hash Browns",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Base Inclusions",
      "rule": "Included",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Base Inclusions",
      "rule": "Included",
      "menuID": "MENU_TROPICAL_FRUIT_KEBAB",
      "menuItem": "Tropical Fruit Kebab",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Base Inclusions",
      "rule": "Included",
      "menuID": "MENU_BOTTLED_WATER",
      "menuItem": "Bottled Water",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Slider or Crostini",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_CHEESEBURGER_SLIDERS",
      "menuItem": "Cheeseburger Sliders",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Slider or Crostini",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_CHUNKY_CHICKEN_EGG_SALAD_SLIDERS",
      "menuItem": "Chunky Chicken & Egg Salad Sliders",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Slider or Crostini",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_ROAST_BEEF_CROSTINI",
      "menuItem": "Roast Beef Crostini",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Slider or Crostini",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
      "menuItem": "Brie & Berry Jam Crostini",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO_PASTA",
      "menuItem": "Homemade Pesto Pasta",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
      "menuItem": "Salted Gooey Brownie Tart",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_VANILLA_CREME_BRULEE_POTS",
      "menuItem": "Vanilla Creme Brulee Pots",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_TIRAMISU",
      "menuItem": "Tiramisu",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_BITES",
      "packageName": "Rustic Bites",
      "category": "Dessert",
      "rule": "30-50 choose 1; 100 choose up to 2",
      "menuID": "MENU_LUXE_CHOCOLATE_MOUSSE",
      "menuItem": "Luxe Chocolate Mousse",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_SPANISH_MEATBALLS",
      "menuItem": "Spanish Meatballs",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS",
      "menuItem": "Mini Chicken Kebab Skewers",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_MINI_CHICKEN_INASAL_SKEWERS",
      "menuItem": "Mini Chicken Inasal Skewers",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_EGG_SALAD_CANAPE",
      "menuItem": "Egg Salad Canape",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_CHICKEN_SALAD_SLIDER",
      "menuItem": "Chicken Salad Slider",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_ROAST_BEEF_CROSTINI",
      "menuItem": "Roast Beef Crostini",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
      "menuItem": "Brie & Berry Jam Crostini",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_CAPRESE_CROSTINI",
      "menuItem": "Caprese Crostini",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_TUNA_TARTLET",
      "menuItem": "Tuna Tartlet",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_SMOKED_SALMON_MOUSSE_TARTLET",
      "menuItem": "Smoked Salmon Mousse Tartlet",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_DUCK_CONFIT_TARTLET",
      "menuItem": "Duck Confit Tartlet",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Canape & Crostini",
      "rule": "Choose 4",
      "menuID": "MENU_DUCK_CONFIT_TARTLET_FOIE_GRAS",
      "menuItem": "Duck Confit Tartlet & Foie Gras",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Bites",
      "rule": "Both included",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Bites",
      "rule": "Both included",
      "menuID": "MENU_PORK_BOULANGERE",
      "menuItem": "Pork Boulangere",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO_PASTA",
      "menuItem": "Homemade Pesto Pasta",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Dessert",
      "rule": "30/50 choose 1; 100 choose 1-2",
      "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
      "menuItem": "Salted Gooey Brownie Tart",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Dessert",
      "rule": "30/50 choose 1; 100 choose 1-2",
      "menuID": "MENU_VANILLA_CREME_BRULEE_POTS",
      "menuItem": "Vanilla Creme Brulee Pots",
      "available": "Yes",
      "recoScore": 1,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Dessert",
      "rule": "30/50 choose 1; 100 choose 1-2",
      "menuID": "MENU_TIRAMISU",
      "menuItem": "Tiramisu",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Refreshments",
      "rule": "Included",
      "menuID": "MENU_SPARKLING_WATER_SODA",
      "menuItem": "Sparkling Water & Soda",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Refreshments",
      "rule": "Included",
      "menuID": "MENU_STILL_WATER",
      "menuItem": "Still Water",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_COCKTAILS",
      "packageName": "Natalia's Rustic Cocktails",
      "category": "Refreshments",
      "rule": "Included",
      "menuID": "MENU_CITRUS_INFUSED_WATER",
      "menuItem": "Citrus-Infused Water",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Cheese & Charcuterie",
      "rule": "Included",
      "menuID": "MENU_CAPRESE",
      "menuItem": "Caprese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Cheese & Charcuterie",
      "rule": "Included",
      "menuID": "MENU_4_ARTISANAL_CHEESES",
      "menuItem": "4 Artisanal Cheeses",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Cheese & Charcuterie",
      "rule": "Included",
      "menuID": "MENU_3_PREMIUM_CHARCUTERIE_CUTS",
      "menuItem": "3 Premium Charcuterie Cuts",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_TROPICAL_FRUIT_KEBAB",
      "menuItem": "Tropical Fruit Kebab",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_GRAPES_BERRIES",
      "menuItem": "Grapes & Berries",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_OLIVES",
      "menuItem": "Olives",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_CRACKERS",
      "menuItem": "Crackers",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Bites",
      "rule": "Included",
      "menuID": "MENU_EGG_SALAD_CANAPE",
      "menuItem": "Egg Salad Canape",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Bites",
      "rule": "Included",
      "menuID": "MENU_ROAST_BEEF_CROSTINI_WITH_CHIMICHURRI",
      "menuItem": "Roast Beef Crostini with Chimichurri",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Bites",
      "rule": "Included",
      "menuID": "MENU_CHEESEBURGER_SLIDERS",
      "menuItem": "Cheeseburger Sliders",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Bites",
      "rule": "Included",
      "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS_WITH_TZATZIKI_DIP",
      "menuItem": "Mini Chicken Kebab Skewers with Tzatziki Dip",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_CLASSIC_GRAZE",
      "packageName": "Classic Graze",
      "category": "Sweet Treat",
      "rule": "Included",
      "menuID": "MENU_BELGIAN_CHOCOLATE_BROWNIE_BITES",
      "menuItem": "Belgian Chocolate Brownie Bites",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Cheese & Charcuterie",
      "rule": "Included",
      "menuID": "MENU_CAPRESE",
      "menuItem": "Caprese",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Cheese & Charcuterie",
      "rule": "Included",
      "menuID": "MENU_4_ARTISANAL_CHEESES",
      "menuItem": "4 Artisanal Cheeses",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Cheese & Charcuterie",
      "rule": "Included",
      "menuID": "MENU_3_PREMIUM_CHARCUTERIE_CUTS",
      "menuItem": "3 Premium Charcuterie Cuts",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_TROPICAL_FRUIT_KEBAB",
      "menuItem": "Tropical Fruit Kebab",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_GRAPES_BERRIES",
      "menuItem": "Grapes & Berries",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_OLIVES",
      "menuItem": "Olives",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Accoutrements",
      "rule": "Included",
      "menuID": "MENU_CRACKERS",
      "menuItem": "Crackers",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Bites",
      "rule": "All included",
      "menuID": "MENU_EGG_SALAD_CANAPE",
      "menuItem": "Egg Salad Canape",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Bites",
      "rule": "All included",
      "menuID": "MENU_ROAST_BEEF_CROSTINI_WITH_CHIMICHURRI",
      "menuItem": "Roast Beef Crostini with Chimichurri",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Bites",
      "rule": "All included",
      "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS",
      "menuItem": "Mini Chicken Kebab Skewers",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Bites",
      "rule": "All included",
      "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
      "menuItem": "Signature Beef Salpicao",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
      "menuItem": "Mighty Meaty Bolognese",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_CREAMED_FETTUCCINE",
      "menuItem": "Creamed Fettuccine",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_HOMEMADE_PESTO_PASTA",
      "menuItem": "Homemade Pesto Pasta",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
      "menuItem": "Mushroom Pasta Rigatoni",
      "available": "Yes",
      "recoScore": null,
      "recoType": null,
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Pasta",
      "rule": "Choose 1",
      "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
      "menuItem": "Truffle Cream Fettuccine",
      "available": "Yes",
      "recoScore": 2,
      "recoType": "Alternative",
      "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
      "notes": null
    },
    {
      "packageID": "RS_SIGNATURE_GRAZE",
      "packageName": "Signature Graze",
      "category": "Sweet Treat",
      "rule": "Included",
      "menuID": "MENU_BELGIAN_DOUBLE_CHOCOLATE_BROWNIE_BITES",
      "menuItem": "Belgian Double Chocolate Brownie Bites",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": null
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_PETITE_CROISSANT_PLATTER",
      "menuItem": "Petite Croissant Platter",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_EGG_SALAD_CANAPE",
      "menuItem": "Egg Salad Canape",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_DOUBLE_CHOCOLATE_BROWNIE_BITES",
      "menuItem": "Double Chocolate Brownie Bites",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_SPANISH_MEATBALLS",
      "menuItem": "Spanish Meatballs",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_MINI_CHICKEN_KEBAB",
      "menuItem": "Mini Chicken Kebab",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_MINI_CHEESE_FRUIT_SPREAD",
      "menuItem": "Mini Cheese & Fruit Spread",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_4_ARTISANAL_CHEESES",
      "menuItem": "4 Artisanal Cheeses",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_1_PREMIUM_CHARCUTERIE_CUT",
      "menuItem": "1 Premium Charcuterie Cut",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_FRUITS_BERRIES",
      "menuItem": "Fruits & Berries",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    },
    {
      "packageID": "RS_LITE",
      "packageName": "Natalia's Rustic Lite",
      "category": "All Selections",
      "rule": "All included",
      "menuID": "MENU_CITRUS_INFUSED_WATER",
      "menuItem": "Citrus-Infused Water",
      "available": "Yes",
      "recoScore": 1,
      "recoType": "Best Fit",
      "upgradePrice": null,
      "notes": "Minimum 100 guests"
    }
  ],
  "menuDatabase": [
    {
      "dishItem": "Signature Beef Salpicao",
      "category": "Beef / Bite",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Wedding; Social; Kiddie",
      "audience": "All",
      "premiumLevel": 5,
      "popularity": 10,
      "defaultReco": "Yes",
      "notes": "Core NRK signature item"
    },
    {
      "dishItem": "Classic U.S. Roast Beef",
      "category": "Beef",
      "serviceFit": "Full Service; Add-on",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Premium/classic alternative"
    },
    {
      "dishItem": "Braised Beef Short Ribs",
      "category": "Beef",
      "serviceFit": "Standard Catering",
      "bestEvents": "Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "6-hr Slow Roasted Pork Belly",
      "category": "Pork Roast",
      "serviceFit": "Full Service",
      "bestEvents": "Wedding; Social; Corporate",
      "audience": "All",
      "premiumLevel": 5,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Included in Rustic B/Signature/Feast/Standard B"
    },
    {
      "dishItem": "American Style Pork BBQ Ribs",
      "category": "Pork",
      "serviceFit": "Rustic A",
      "bestEvents": "Kiddie; Social",
      "audience": "Families",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Pork Boulangere",
      "category": "Bite / Carving",
      "serviceFit": "Stations; Add-on",
      "bestEvents": "Corporate Cocktails; Social",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Three Cheese Baked Prawns",
      "category": "Seafood",
      "serviceFit": "Rustic Feast",
      "bestEvents": "Wedding; Premium Social",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Feast included main"
    },
    {
      "dishItem": "Seared Norwegian Salmon with Mushroom Cream Sauce",
      "category": "Seafood",
      "serviceFit": "Full Service",
      "bestEvents": "Corporate; Wedding",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Premium profile"
    },
    {
      "dishItem": "Shrimp & Chorizo Al Ajillo",
      "category": "Seafood",
      "serviceFit": "Full Service",
      "bestEvents": "Social; Corporate",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Rustic/adult flavor"
    },
    {
      "dishItem": "Golden Cream Dory Fillet with Tartar Sauce",
      "category": "Fish",
      "serviceFit": "Standard Catering",
      "bestEvents": "Corporate; Social",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Creamy Herb Garlic Chicken",
      "category": "Chicken",
      "serviceFit": "Full Service; Standard",
      "bestEvents": "Corporate; Wedding; Social",
      "audience": "All",
      "premiumLevel": 4,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Safe premium crowd-pleaser"
    },
    {
      "dishItem": "Chicken Inasal",
      "category": "Chicken",
      "serviceFit": "Full Service; Standard",
      "bestEvents": "Social; Family; Kiddie",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Familiar Filipino favorite"
    },
    {
      "dishItem": "Chicken Kebab with Tzatziki Dip",
      "category": "Chicken",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Social; Cocktails",
      "audience": "All",
      "premiumLevel": 4,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Works well for cocktails"
    },
    {
      "dishItem": "Traditional Roast Chicken",
      "category": "Chicken",
      "serviceFit": "Full Service; Standard",
      "bestEvents": "Social; Corporate",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Chicken Teriyaki",
      "category": "Chicken",
      "serviceFit": "Full Service; Standard",
      "bestEvents": "Kiddie; Social; Corporate",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Jamaican Jerk Chicken",
      "category": "Chicken",
      "serviceFit": "Full Service; Standard",
      "bestEvents": "Social; Corporate",
      "audience": "Adults",
      "premiumLevel": 3,
      "popularity": 6,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Classic Chicken BBQ",
      "category": "Chicken",
      "serviceFit": "Standard Catering",
      "bestEvents": "Kiddie; Social",
      "audience": "Families",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Chicken Tenders with Glazed Doughnut Poppers",
      "category": "Chicken / Kiddie",
      "serviceFit": "Rustic A; Rustic Bites",
      "bestEvents": "Kiddie Party",
      "audience": "Kids",
      "premiumLevel": 1,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Kid-friendly"
    },
    {
      "dishItem": "Rustic Caesar Salad",
      "category": "Salad",
      "serviceFit": "Full Service",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Summer Salad",
      "category": "Salad",
      "serviceFit": "Full Service",
      "bestEvents": "Social; Wedding",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Greek Salad",
      "category": "Salad",
      "serviceFit": "Full Service",
      "bestEvents": "Corporate; Wedding; Social",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Fresh and premium"
    },
    {
      "dishItem": "Asian Soba Slaw Salad",
      "category": "Salad",
      "serviceFit": "Full Service",
      "bestEvents": "Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Mesclun Greens with Balsamic Dressing",
      "category": "Salad",
      "serviceFit": "Standard Catering",
      "bestEvents": "Corporate; Social",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Mighty Meaty Bolognese",
      "category": "Pasta",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Kiddie; Social; Corporate",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Good family/kiddie option"
    },
    {
      "dishItem": "Creamed Fettuccine",
      "category": "Pasta",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Social; Corporate",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Homemade Pesto Pasta",
      "category": "Pasta",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Mushroom Pasta Rigatoni",
      "category": "Pasta",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Wedding; Social",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 7,
      "defaultReco": null,
      "notes": "Truffle upgrade available"
    },
    {
      "dishItem": "Truffle Cream Fettuccine",
      "category": "Pasta",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Wedding; Premium Social",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "+P30/head"
    },
    {
      "dishItem": "Vanilla Crème Brulee Pots",
      "category": "Dessert",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Wedding; Social",
      "audience": "All",
      "premiumLevel": 5,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Premium plated/pot dessert feel"
    },
    {
      "dishItem": "Tiramisu",
      "category": "Dessert",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Wedding; Social",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Adult dessert"
    },
    {
      "dishItem": "Luxe Belgian Chocolate Mousse",
      "category": "Dessert",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Social",
      "audience": "All",
      "premiumLevel": 4,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Salted Gooey Brownie Tart",
      "category": "Dessert",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Kiddie; Social; Corporate",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": "Crowd favorite"
    },
    {
      "dishItem": "Leche Flan",
      "category": "Dessert",
      "serviceFit": "Standard Catering",
      "bestEvents": "Social; Family",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Familiar Filipino dessert"
    },
    {
      "dishItem": "Creamy Cathedral Window Jelly",
      "category": "Dessert",
      "serviceFit": "Standard Catering",
      "bestEvents": "Social; Family",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Double Chocolate Belgian Brownie Bites",
      "category": "Dessert",
      "serviceFit": "Standard; Stations; Lite",
      "bestEvents": "Kiddie; Social; Corporate",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Peach & Mango Parfait",
      "category": "Dessert",
      "serviceFit": "Standard Catering",
      "bestEvents": "Social; Corporate",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": "Indoor recommended"
    },
    {
      "dishItem": "Spanish Meatballs",
      "category": "Canape / Bite",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Corporate Cocktails; Social",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Mini Chicken Inasal Skewers",
      "category": "Canape / Bite",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Social; Corporate; Family",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Egg Salad Canape",
      "category": "Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Social; Corporate",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Chicken Salad Slider",
      "category": "Canape / Slider",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Social; Corporate",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Roast Beef Crostini",
      "category": "Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Corporate; Wedding; Social",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Brie & Berry Jam Crostini",
      "category": "Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Caprese Crostini",
      "category": "Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Tuna Tartlet",
      "category": "Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Corporate; Social",
      "audience": "Adults",
      "premiumLevel": 4,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Smoked Salmon Mousse Tartlet",
      "category": "Premium Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Wedding; Corporate",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 7,
      "defaultReco": null,
      "notes": "Upgrade +P20/head"
    },
    {
      "dishItem": "Duck Confit Tartlet",
      "category": "Premium Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Premium Social; Wedding",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 6,
      "defaultReco": null,
      "notes": "Upgrade +P70/head"
    },
    {
      "dishItem": "Duck Confit Tartlet & Foie Gras",
      "category": "Premium Canape",
      "serviceFit": "Stations; Signature; Feast",
      "bestEvents": "Premium Wedding; VIP Corporate",
      "audience": "Adults",
      "premiumLevel": 5,
      "popularity": 5,
      "defaultReco": null,
      "notes": "Upgrade +P140/head"
    },
    {
      "dishItem": "Cheeseburger Sliders",
      "category": "Slider",
      "serviceFit": "Rustic Bites; Classic Graze",
      "bestEvents": "Kiddie; Social",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 9,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Chunky Chicken & Egg Salad Sliders",
      "category": "Slider",
      "serviceFit": "Rustic Bites",
      "bestEvents": "Kiddie; Social",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Croissant Petite Platter",
      "category": "Pastry",
      "serviceFit": "Rustic Bites; Rustic Lite",
      "bestEvents": "Brunch; Kiddie; Corporate Social",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Mini Hash Browns",
      "category": "Side",
      "serviceFit": "Rustic Bites",
      "bestEvents": "Kiddie; Brunch",
      "audience": "Kids",
      "premiumLevel": 1,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Tropical Fruit Kebab",
      "category": "Fruit / Add-on",
      "serviceFit": "Full Service; Stations",
      "bestEvents": "Corporate; Social; Kiddie",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": "Complimentary option for 100+ full service/stations"
    },
    {
      "dishItem": "Roasted Pumpkin Soup",
      "category": "Soup",
      "serviceFit": "Feast; Soup Add-on",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": "Yes",
      "notes": null
    },
    {
      "dishItem": "Potato & Leek Soup",
      "category": "Soup",
      "serviceFit": "Feast; Soup Add-on",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Mushroom Soup",
      "category": "Soup",
      "serviceFit": "Feast; Soup Add-on",
      "bestEvents": "Wedding; Corporate; Social",
      "audience": "All",
      "premiumLevel": 3,
      "popularity": 8,
      "defaultReco": null,
      "notes": null
    },
    {
      "dishItem": "Tomato Soup",
      "category": "Soup",
      "serviceFit": "Feast; Soup Add-on",
      "bestEvents": "Social; Corporate",
      "audience": "All",
      "premiumLevel": 2,
      "popularity": 7,
      "defaultReco": null,
      "notes": null
    }
  ],
  "addons": [
    {
      "addOnID": "ADD_KIDDIE",
      "addOnName": "Kiddie Buffet",
      "category": "Food",
      "availableFor": "Full Service Catering",
      "pricing": "₱475/head",
      "minTiers": "Minimum 20 kids",
      "recommendFor": "Children's Parties",
      "reasonTemplate": "This is helpful when you want a separate, child-friendly spread while adults enjoy the main buffet",
      "sourceNotes": "Full service add-on"
    },
    {
      "addOnID": "ADD_MINI_GRAZE",
      "addOnName": "Mini Graze",
      "category": "Food",
      "availableFor": "Main Catering Packages",
      "pricing": "₱375/head",
      "minTiers": "Minimum 30 pax",
      "recommendFor": "Weddings; Birthdays & Social Celebrations",
      "reasonTemplate": "A lovely addition to your buffet, featuring a simple selection of cheeses for guests to enjoy alongside the main spread",
      "sourceNotes": "Full service add-on"
    },
    {
      "addOnID": "ADD_SOUP",
      "addOnName": "Soup Service",
      "category": "Food",
      "availableFor": "Main Catering Packages",
      "pricing": "₱110/head",
      "minTiers": "Minimum 30 pax",
      "recommendFor": "Corporate Events",
      "reasonTemplate": "A comforting soup, prepared from scratch and served as a warm, familiar start to the meal",
      "sourceNotes": "Full service add-on"
    },
    {
      "addOnID": "ADD_HAM",
      "addOnName": "Ham & Pan de Sal Station",
      "category": "Food Station",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "₱9,000/50; ₱16,500/100",
      "minTiers": "50 or 100 pax",
      "recommendFor": null,
      "reasonTemplate": "A festive add-on that works well for holiday gatherings and family-style celebrations",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_PORK_BOULANGERE",
      "addOnName": "Pork Boulangere Carving Station",
      "category": "Food Station",
      "availableFor": "Rustic Stations",
      "pricing": "₱6,000/30; ₱9,000/50; ₱16,500/100",
      "minTiers": "Minimum of 30 pax",
      "recommendFor": "Cocktail & Networking Events",
      "reasonTemplate": "Our signature traditional pork roast, freshly carved as part of your rustic station",
      "sourceNotes": "Rustic station add-on"
    },
    {
      "addOnID": "ADD_ROAST_BEEF",
      "addOnName": "Classic U.S. Roast Beef Carving Station",
      "category": "Food Station",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "₱7,000/30; ₱10,000/50; ₱18,000/100",
      "minTiers": "Minimum of 30 pax",
      "recommendFor": null,
      "reasonTemplate": "A strong premium upgrade when you want a classic centerpiece dish.",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_PRIME_RIB",
      "addOnName": "U.S. Prime Rib Roast",
      "category": "Food Station",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "Price upon request",
      "minTiers": null,
      "recommendFor": "Birthdays & Social Celebrations",
      "reasonTemplate": "A premium carving station featuring roasted vegetables and a selection of classic steak sauces",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_FOIE_GRAS",
      "addOnName": "On-the-Spot Foie Gras Station",
      "category": "Food Station",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "Price upon request",
      "minTiers": "Venue must allow open flame",
      "recommendFor": "Cocktail & Networking Events",
      "reasonTemplate": "A premium live-cooking station for venues that allow open-fire cooking.",
      "sourceNotes": "Requires open fire"
    },
    {
      "addOnID": "ADD_COFFEE_FULL",
      "addOnName": "Freshly Brewed Arabica Coffee",
      "category": "Beverage",
      "availableFor": "Full Service Catering",
      "pricing": "₱2,500/50; ₱5,000/100",
      "minTiers": "50/100 pax",
      "recommendFor": null,
      "reasonTemplate": "Ideal when the event runs into the afternoon or includes a program.",
      "sourceNotes": "Full service price"
    },
    {
      "addOnID": "ADD_BEV_TUB",
      "addOnName": "Natalia's Beverage Tub",
      "category": "Beverage",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "₱4,200/30; ₱6,600/50; ₱12,600/100",
      "minTiers": "Minimum of 30 pax",
      "recommendFor": "Birthdays & Social Celebrations; Children's Parties",
      "reasonTemplate": "An easy refreshment upgrade featuring flavored sparkling drinks and sparkling water.",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_BEER_TUB",
      "addOnName": "Natalia's Beer Tub",
      "category": "Beverage",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "₱6,500/30; ₱9,500/50; ₱17,800/100",
      "minTiers": "Minimum of 30 pax",
      "recommendFor": "Corporate Events",
      "reasonTemplate": "Works well for casual after-office or laid-back celebrations.",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_PIMMS",
      "addOnName": "Natalia's Pimm's Cup",
      "category": "Beverage",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "₱8,400/30; ₱13,500/50; ₱25,000/100",
      "minTiers": "Minimum of 30 pax",
      "recommendFor": "Weddings; Birthdays & Social Celebrations",
      "reasonTemplate": "A refreshing cocktail made with Pimm’s, a gin-based liqueur, served with fruit for relaxed gatherings and easy conversation",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_WINE",
      "addOnName": "Wine Service",
      "category": "Beverage",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "Italian Red ₱1,200/bottle; French White ₱1,000/bottle",
      "minTiers": "Minimum 6 bottles / 12 glasses",
      "recommendFor": "Cocktail & Networking Events",
      "reasonTemplate": "A curated wine selection that pairs beautifully with cheese and light bites for a relaxed networking experience",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_COCKTAIL_TABLE",
      "addOnName": "Cocktail Tables with Rustic Centerpiece",
      "category": "Service / Dining",
      "availableFor": "Full Service; Rustic Stations",
      "pricing": "₱350/table",
      "minTiers": "Per table",
      "recommendFor": "Cocktail & Networking Events",
      "reasonTemplate": "Adds comfort and structure for guests during mingling events.",
      "sourceNotes": null
    },
    {
      "addOnID": "ADD_RUSTIC_DINING",
      "addOnName": "Rustic Dining Set-up Upgrade",
      "category": "Service / Dining",
      "availableFor": "Rustic Stations",
      "pricing": "₱6,000/30; ₱9,500/50; ₱17,500/100",
      "minTiers": "30/50/100 pax",
      "recommendFor": "Birthdays & Social Celebrations",
      "reasonTemplate": "Recommended if you want a cocktail/grazing package but guests still need proper dining tables and chairs.",
      "sourceNotes": "Rustic station dining upgrade"
    },
    {
      "addOnID": "ADD_LECHON_SERVICE",
      "addOnName": "Lechon Service",
      "category": "Service",
      "availableFor": "Full Service Catering",
      "pricing": 1500,
      "minTiers": "Max 2 lechon",
      "recommendFor": "Birthdays & Social Celebrations",
      "reasonTemplate": "Useful if client is bringing lechon and wants proper service support.",
      "sourceNotes": "Full service add-on"
    },
    {
      "addOnID": "ADD_CLASSIC_GRAZE",
      "addOnName": "Classic Graze",
      "category": "Grazing",
      "availableFor": "Full Service",
      "pricing": "₱34,250/30; ₱48,000/50; ₱95,000/100",
      "minTiers": "Minimum of 30 pax",
      "recommendFor": "Children's Parties; Weddings, Corporate Events",
      "reasonTemplate": "A generous grazing spread guests can enjoy before the main meal.",
      "sourceNotes": "3–4 hours or until consumed; exclusive of 12% VAT, 5% service charge, and transport/mobilization"
    }
  ],
  "addonEventThemeMap": [
    {
      "addOnID": "ADD_KIDDIE",
      "addOnName": "Kiddie Buffet",
      "birthdaysSocialCelebrations": null,
      "childrensParties": "Yes",
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": null,
      "notes": "Minimum 20 kids"
    },
    {
      "addOnID": "ADD_MINI_GRAZE",
      "addOnName": "Mini Graze",
      "birthdaysSocialCelebrations": "Yes",
      "childrensParties": null,
      "weddings": "Yes",
      "corporateEvents": "Yes",
      "cocktailNetworkingEvents": null,
      "notes": "Good general upgrade"
    },
    {
      "addOnID": "ADD_SOUP",
      "addOnName": "Soup Service",
      "birthdaysSocialCelebrations": null,
      "weddings": "Yes",
      "corporateEvents": "Yes",
      "cocktailNetworkingEvents": null,
      "notes": "Best for full meal events"
    },
    {
      "addOnID": "ADD_HAM",
      "addOnName": "Ham & Pan de Sal Station",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": "Yes",
      "cocktailNetworkingEvents": null,
      "notes": "Good holiday/social/corporate add-on"
    },
    {
      "addOnID": "ADD_PORK_BOULANGERE",
      "addOnName": "Pork Boulangere Carving Station",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": "Yes",
      "notes": "Good for stations"
    },
    {
      "addOnID": "ADD_ROAST_BEEF",
      "addOnName": "Classic U.S. Roast Beef Carving Station",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": null,
      "notes": "Premium full meal add-on"
    },
    {
      "addOnID": "ADD_PRIME_RIB",
      "addOnName": "U.S. Prime Rib Roast",
      "birthdaysSocialCelebrations": "Yes",
      "weddings": "Yes",
      "corporateEvents": null,
      "cocktailNetworkingEvents": null,
      "notes": "Manual quote"
    },
    {
      "addOnID": "ADD_FOIE_GRAS",
      "addOnName": "On-the-Spot Foie Gras Station",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": "Yes",
      "notes": "Venue must allow open flame"
    },
    {
      "addOnID": "ADD_COFFEE_FULL",
      "addOnName": "Freshly Brewed Arabica Coffee",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": null,
      "notes": "Full service coffee"
    },
    {
      "addOnID": "ADD_BEV_TUB",
      "addOnName": "Natalia's Beverage Tub",
      "birthdaysSocialCelebrations": "Yes",
      "childrensParties": "Yes",
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": null,
      "notes": "General beverage upgrade"
    },
    {
      "addOnID": "ADD_BEER_TUB",
      "addOnName": "Natalia's Beer Tub",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": "Yes",
      "cocktailNetworkingEvents": null,
      "notes": "Casual corporate/networking"
    },
    {
      "addOnID": "ADD_PIMMS",
      "addOnName": "Natalia's Pimm's Cup",
      "birthdaysSocialCelebrations": "Yes",
      "weddings": "Yes",
      "corporateEvents": null,
      "cocktailNetworkingEvents": "Yes",
      "notes": "Signature drink"
    },
    {
      "addOnID": "ADD_WINE",
      "addOnName": "Wine Service",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": "Yes",
      "notes": "Minimum bottles/glasses apply"
    },
    {
      "addOnID": "ADD_RUSTIC_DINING",
      "addOnName": "Rustic Dining Set-up Upgrade",
      "birthdaysSocialCelebrations": null,
      "weddings": null,
      "corporateEvents": null,
      "cocktailNetworkingEvents": "Yes",
      "notes": "For intimate/prettier dining"
    },
    {
      "addOnID": "ADD_CLASSIC_GRAZE",
      "addOnName": "Classic Graze",
      "birthdaysSocialCelebrations": null,
      "childrensParties": "Yes",
      "weddings": "Yes",
      "corporateEvents": "Yes",
      "cocktailNetworkingEvents": null,
      "notes": "A generous grazing spread guests can enjoy before the main meal"
    }
  ],
  "locationRules": [
    {
      "locationID": "LOC_METRO_MANILA",
      "locationOption": "Metro Manila",
      "serviceStatus": "Serviced",
      "plannerAction": "Allow instant recommendation",
      "eligiblePackageLogic": "Use standard package scoring",
      "minimumPreQualification": "Apply regular package minimums; December minimums still apply",
      "manualReviewFlag": "No",
      "clientFacingNote": "We service Metro Manila. Final quotation may include mobilization depending on venue and final service requirements."
    },
    {
      "locationID": "LOC_CAVITE",
      "locationOption": "Cavite",
      "serviceStatus": "Serviced",
      "plannerAction": "Allow instant recommendation",
      "eligiblePackageLogic": "Use standard package scoring",
      "minimumPreQualification": "Apply regular package minimums; December minimums still apply",
      "manualReviewFlag": "No",
      "clientFacingNote": "We service Cavite. Final quotation may include mobilization depending on venue and final service requirements."
    },
    {
      "locationID": "LOC_TAGAYTAY",
      "locationOption": "Tagaytay",
      "serviceStatus": "Serviced",
      "plannerAction": "Allow instant recommendation",
      "eligiblePackageLogic": "Use Cavite / out-of-base mobilization review",
      "minimumPreQualification": "Apply regular package minimums unless otherwise reviewed",
      "manualReviewFlag": "Maybe",
      "clientFacingNote": "We cater Tagaytay events. Final quotation may include mobilization depending on venue and final service requirements."
    },
    {
      "locationID": "LOC_LAGUNA",
      "locationOption": "Laguna",
      "serviceStatus": "Serviced",
      "plannerAction": "Allow recommendation but flag review",
      "eligiblePackageLogic": "Use standard package scoring",
      "minimumPreQualification": "Check exact city and venue before final quote",
      "manualReviewFlag": "Maybe",
      "clientFacingNote": "We service select Laguna areas. Final quotation may include mobilization depending on venue and final service requirements."
    },
    {
      "locationID": "LOC_BATANGAS",
      "locationOption": "Batangas",
      "serviceStatus": "Select Areas / Manual Review",
      "plannerAction": "Pre-qualify before package recommendation",
      "eligiblePackageLogic": "Rustic min 50; Standard min 70; final availability review required",
      "minimumPreQualification": "If pax below Batangas minimum, do not show instant package recommendation",
      "manualReviewFlag": "Yes",
      "clientFacingNote": "For Batangas, minimums and mobilization depend on exact location and package."
    },
    {
      "locationID": "LOC_OTHER",
      "locationOption": "Other / Outside Nearby Areas",
      "serviceStatus": "Manual Review",
      "plannerAction": "Do not auto-recommend; collect details",
      "eligiblePackageLogic": "No instant package scoring",
      "minimumPreQualification": "Ask for exact venue and event details",
      "manualReviewFlag": "Yes",
      "clientFacingNote": "Please share your exact location so our team can confirm if we can service the area."
    }
  ],
  "recommendationRules": [
    {
      "ruleID": "RULE_EVENT_THEME",
      "inputTrigger": "Event type selected",
      "logic": "Use one of the four master event themes only",
      "output": "Route to Package_Scoring",
      "manualReviewFlag": "No"
    },
    {
      "ruleID": "RULE_SCORE_1",
      "inputTrigger": "Recommended Default",
      "logic": "Show first under Best Fit",
      "output": "Primary recommendation",
      "manualReviewFlag": "No"
    },
    {
      "ruleID": "RULE_SCORE_2",
      "inputTrigger": "Alternative",
      "logic": "Show after Best Fit under Alternatives",
      "output": "Alternative recommendation",
      "manualReviewFlag": "No"
    },
    {
      "ruleID": "RULE_BLANK",
      "inputTrigger": "Package or dish score is blank",
      "logic": "Do not show to client",
      "output": "Hidden",
      "manualReviewFlag": "No"
    },
    {
      "ruleID": "RULE_KIDDIE",
      "inputTrigger": "Birthdays & Social + children/kids mentioned",
      "logic": "Recommend Kiddie Buffet add-on if 20 kids+",
      "output": "Add-on suggestion",
      "manualReviewFlag": "Maybe"
    },
    {
      "ruleID": "RULE_WEDDING",
      "inputTrigger": "Weddings selected",
      "logic": "Lead with Signature / Rustic B; do not say full wedding package",
      "output": "Wedding-friendly catering options",
      "manualReviewFlag": "No"
    },
    {
      "ruleID": "RULE_COCKTAIL",
      "inputTrigger": "Cocktail & Networking selected",
      "logic": "Prioritize Rustic Cocktails and Signature Graze",
      "output": "Station-style recommendation",
      "manualReviewFlag": "No"
    },
    {
      "ruleID": "RULE_CORP_VOLUME",
      "inputTrigger": "Corporate + very large pax or low budget",
      "logic": "Flag for custom review",
      "output": "Manual commercial review",
      "manualReviewFlag": "Yes"
    },
    {
      "ruleID": "RULE_DECEMBER",
      "inputTrigger": "December event",
      "logic": "Apply December minimums from Package_Rules",
      "output": "Eligibility filter",
      "manualReviewFlag": "Maybe"
    },
    {
      "ruleID": "RULE_BELOW_MIN",
      "inputTrigger": "Pax below package minimum",
      "logic": "Suggest Party Trays if within delivery area or ask to increase pax",
      "output": "Do not force full catering quote",
      "manualReviewFlag": "Maybe"
    },
    {
      "ruleID": "RULE_MENU_OUTPUT",
      "inputTrigger": "Package selected",
      "logic": "Filter Menu_Scoring by selected package: 1 = Best Fit, 2 = Alternatives",
      "output": "Curated menu recommendation",
      "manualReviewFlag": "No"
    }
  ],
  "plannerFlow": [
    {
      "step": 1,
      "clientSees": "I already know what I need / Help me choose",
      "backendLogic": "Route choice",
      "output": "Direct Hulk Form OR Event Planner"
    },
    {
      "step": 2,
      "clientSees": "What type of event are you planning?",
      "backendLogic": "Event_Types + Package_Scoring",
      "output": "Initial service route"
    },
    {
      "step": 3,
      "clientSees": "Where is your event?",
      "backendLogic": "Venue/mobilization review later",
      "output": "Location tag / manual review flag"
    },
    {
      "step": 4,
      "clientSees": "How many guests?",
      "backendLogic": "Minimum pax + pricing matrix",
      "output": "Eligible packages"
    },
    {
      "step": 5,
      "clientSees": "Investment range",
      "backendLogic": "Budget_Compatibility",
      "output": "Excellent / Good / Stretch / Special Review"
    },
    {
      "step": 6,
      "clientSees": "Assistant Recommendation",
      "backendLogic": "Package scores + dish reco + add-ons",
      "output": "Best Fit + Alternative"
    },
    {
      "step": 7,
      "clientSees": "Continue to Formal Proposal",
      "backendLogic": "Hulk_Form_Mapping",
      "output": "Prefilled or hidden fields in Hulk"
    }
  ],
  "responseLibrary": [
    {
      "responseID": "INTRO",
      "useCase": "Opening",
      "assistantCopy": "Hi! I’m Natalia’s Event Planner. I’ll help you find the most suitable catering direction based on your event type, location, and guest count."
    },
    {
      "responseID": "RECO_HEADER",
      "useCase": "Recommendation intro",
      "assistantCopy": "Based on what you shared, I’d recommend two possible directions for your event."
    },
    {
      "responseID": "NO_PDF_NOTE",
      "useCase": "Menu exposure",
      "assistantCopy": "Rather than overwhelming you with every menu option, I’ve shortlisted a menu combination that I think will suit your event best. Other selections can still be discussed in the formal proposal."
    },
    {
      "responseID": "CORP_LUNCH",
      "useCase": "Corporate lunch reco",
      "assistantCopy": "For a corporate lunch or dinner, I’d lean toward a full-service buffet with a polished but familiar menu. This gives your guests a complete dining experience while keeping the flow smooth for meetings, programs, or client-facing events."
    },
    {
      "responseID": "CORP_COCKTAILS",
      "useCase": "Corporate cocktails reco",
      "assistantCopy": "Since your guests will likely be mingling, I’d recommend a cocktail-style spread rather than a traditional buffet. This makes the food easier to enjoy while guests are networking or moving around."
    },
    {
      "responseID": "WEDDING",
      "useCase": "Wedding reco",
      "assistantCopy": "For a wedding reception, I’d keep the recommendation within full-service catering so the experience feels complete and properly supported with dining setup, buffet service, and guest assistance."
    },
    {
      "responseID": "KIDDIE",
      "useCase": "Kiddie reco",
      "assistantCopy": "For a kiddie party, I’d recommend a menu that works for both children and adults, with familiar dishes and easy-to-enjoy bites."
    },
    {
      "responseID": "STRETCH",
      "useCase": "Budget stretch",
      "assistantCopy": "Thank you for sharing your preferred investment. Based on the event type, guest count, and location, this range may be challenging for the experience described. We don’t want to recommend a package that won’t meet expectations, but our team can review options if your budget has some flexibility."
    },
    {
      "responseID": "ADDON_INTRO",
      "useCase": "Add-on intro",
      "assistantCopy": "You may also want to consider these add-ons, depending on your program and guest flow."
    },
    {
      "responseID": "HULK_HANDOFF",
      "useCase": "Formal proposal button copy",
      "assistantCopy": "Continue to Formal Proposal"
    }
  ],
  "hulkFormMapping": [
    {
      "fieldName": "Event Type",
      "sourceFromPlanner": "Q1 selected event type",
      "uRLParameter": "event_type",
      "hiddenOrVisible": "Hidden or Visible",
      "notes": "Can prefill Hulk field"
    },
    {
      "fieldName": "Location",
      "sourceFromPlanner": "Q2 selected location",
      "uRLParameter": "location",
      "hiddenOrVisible": "Hidden or Visible",
      "notes": null
    },
    {
      "fieldName": "Guest Count",
      "sourceFromPlanner": "Q3 pax",
      "uRLParameter": "pax",
      "hiddenOrVisible": "Hidden or Visible",
      "notes": null
    },
    {
      "fieldName": "Best Fit Package",
      "sourceFromPlanner": "Recommendation result",
      "uRLParameter": "best_fit",
      "hiddenOrVisible": "Hidden",
      "notes": "Sales team sees recommendation"
    },
    {
      "fieldName": "Alternative Package",
      "sourceFromPlanner": "Recommendation result",
      "uRLParameter": "alternative",
      "hiddenOrVisible": "Hidden",
      "notes": null
    },
    {
      "fieldName": "Suggested Menu",
      "sourceFromPlanner": "Generated menu combination",
      "uRLParameter": "suggested_menu",
      "hiddenOrVisible": "Hidden / long text",
      "notes": "May need textarea"
    },
    {
      "fieldName": "Suggested Add-ons",
      "sourceFromPlanner": "Generated add-ons",
      "uRLParameter": "addons",
      "hiddenOrVisible": "Hidden / long text",
      "notes": null
    },
    {
      "fieldName": "Source",
      "sourceFromPlanner": "Static value",
      "uRLParameter": "source",
      "hiddenOrVisible": "Hidden",
      "notes": "Event Planner"
    }
  ],
  "rawSheets": {
    "README": [
      {
        "nRKEventPlannerDecisionEngine": "Four Event Themes",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Birthdays & Social Celebrations; Weddings; Corporate Events; Cocktail & Networking Events"
      },
      {
        "nRKEventPlannerDecisionEngine": "Score 1",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Best Fit / Primary Recommendation"
      },
      {
        "nRKEventPlannerDecisionEngine": "Score 2",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Alternative / Also Recommended"
      },
      {
        "nRKEventPlannerDecisionEngine": "Blank",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Not recommended / hide from client-facing output"
      },
      {
        "nRKEventPlannerDecisionEngine": "New / Updated Tabs",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Event_Types, Package_Scoring, Menu_Scoring, Addon_Event_Theme_Map, Recommendation_Rules, Scoring_Guide"
      },
      {
        "nRKEventPlannerDecisionEngine": "New sheet",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Package_Menus_Normalized = one package/menu item per row for JSON export"
      },
      {
        "nRKEventPlannerDecisionEngine": "New sheet",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Location_Rules = location pre-qualification layer before recommendations"
      },
      {
        "nRKEventPlannerDecisionEngine": "Note",
        "updatedForFourEventThemesAndSimplified12RecommendationScoring": "Location is asked in the planner, then filtered through Location_Rules before Package_Scoring."
      }
    ],
    "Event_Types": [
      {
        "eventThemeID": "EV_BIRTHDAYS_SOCIAL",
        "eventTheme": "Birthdays & Social Celebrations",
        "exampleEvents": "1st Birthday; Kids Birthday; Adult Birthday; Baptism; Baby Shower; Bridal Shower; Debut; Graduation; Housewarming; Anniversary; Family Reunion; Holiday Party; Retirement; Celebration of Life",
        "primaryServiceRoute": "Full Service Catering or Rustic Stations",
        "secondaryRouteAddOns": "Party Trays for small/simple events; Kiddie Buffet; Styling; Mini Graze; Beverage Tub",
        "defaultBestFit": "FC_RUSTIC_B",
        "defaultAlternative": "FC_SIGNATURE",
        "assistantTone": "Warm, friendly and consultative"
      },
      {
        "eventThemeID": "EV_CORPORATE",
        "eventTheme": "Corporate Events",
        "exampleEvents": "Office Lunch; Office Dinner; Seminar; Workshop; Training; Conference; Board Meeting; Product Launch; Town Hall; Team Building; Christmas Party; Client Appreciation; Company Anniversary",
        "primaryServiceRoute": "Full Service Catering",
        "secondaryRouteAddOns": "Rustic Lite for short/large format; Rustic Stations; Coffee; Beverage Stations",
        "defaultBestFit": "FC_SIGNATURE",
        "defaultAlternative": "ST_B",
        "assistantTone": "Professional, efficient and solutions-focused"
      },
      {
        "eventThemeID": "EV_COCKTAIL_NETWORKING",
        "eventTheme": "Cocktail & Networking Events",
        "exampleEvents": "Networking Night; Brand Launch; Gallery Opening; Store Opening; Media Event; Wine Reception; Open House; Fundraiser; Community Event; Influencer Event",
        "primaryServiceRoute": "Rustic Stations",
        "secondaryRouteAddOns": "Signature Graze; Rustic Cocktails; Beverage Stations; Cocktail Tables",
        "defaultBestFit": "RS_COCKTAILS",
        "defaultAlternative": "RS_SIGNATURE_GRAZE",
        "assistantTone": "Polished and businesslike"
      },
      {
        "eventThemeID": "EV_WEDDINGS",
        "eventTheme": "Weddings",
        "exampleEvents": "Garden Wedding; Church Reception; Civil Wedding; Intimate Wedding; Engagement Party; Solemnization; Cocktail Hour",
        "primaryServiceRoute": "Full Service Catering",
        "secondaryRouteAddOns": "Rustic Cocktails; Signature Graze; Long Table Styling; Beverage Stations",
        "defaultBestFit": "FC_SIGNATURE",
        "defaultAlternative": "FC_RUSTIC_B",
        "assistantTone": "Premium, reassuring and detail-oriented"
      }
    ],
    "Packages": [
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "serviceType": "Full Service Catering",
        "bestFor": "Kiddie parties, family celebrations",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "4 hours",
        "pricingBasis": "Per head",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "serviceType": "Full Service Catering",
        "bestFor": "Socials, weddings, family/corporate dining",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "4 hours",
        "pricingBasis": "Per head",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "serviceType": "Full Service Catering",
        "bestFor": "Premium socials, weddings, corporate entertaining",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "4 hours",
        "pricingBasis": "Per head",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "serviceType": "Full Service Catering",
        "bestFor": "Premium / elevated full meal",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "4 hours",
        "pricingBasis": "Per head",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "serviceType": "Full Service Catering",
        "bestFor": "Simpler crowd-favorite buffet",
        "minPaxRegular": 50,
        "minPaxPeakDec": 70,
        "serviceHours": "4 hours",
        "pricingBasis": "Per head",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "serviceType": "Full Service Catering",
        "bestFor": "Simple buffet with pork roast",
        "minPaxRegular": 50,
        "minPaxPeakDec": 70,
        "serviceHours": "4 hours",
        "pricingBasis": "Per head",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "serviceType": "Rustic Station",
        "bestFor": "Relaxed celebrations and kiddie parties",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "3–4 hours or until consumed",
        "pricingBasis": "Fixed tier",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "serviceType": "Rustic Station",
        "bestFor": "Socials, corporate entertaining, networking, weddings",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "3–4 hours or until consumed",
        "pricingBasis": "Fixed tier",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "serviceType": "Rustic Station",
        "bestFor": "Light refreshments, socials, corporate entertainings, networkings, weddings",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "3–4 hours or until consumed",
        "pricingBasis": "Fixed tier",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "serviceType": "Rustic Station",
        "bestFor": "More abundant grazing with pasta and bites",
        "minPaxRegular": 30,
        "minPaxPeakDec": 50,
        "serviceHours": "3–4 hours or until consumed",
        "pricingBasis": "Fixed tier",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "serviceType": "Rustic Station",
        "bestFor": "Short-format events, brunch, corporate socials, weddings",
        "minPaxRegular": 100,
        "minPaxPeakDec": 100,
        "serviceHours": "3–4 hours or until consumed",
        "pricingBasis": "Fixed tier",
        "vATSCNote": "Exclusive of 12% VAT + 5% SC + transport/mobilization",
        "websiteExposure": "Recommend only"
      }
    ],
    "Pricing_Matrix": [
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "tierLabel": "30-40 pax",
        "paxFrom": 30,
        "paxTo": 40,
        "basePrice": 1100,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "tierLabel": "50-90 pax",
        "paxFrom": 50,
        "paxTo": 90,
        "basePrice": 1030,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 1000,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "tierLabel": "30-40 pax",
        "paxFrom": 30,
        "paxTo": 40,
        "basePrice": 1220,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "tierLabel": "50-90 pax",
        "paxFrom": 50,
        "paxTo": 90,
        "basePrice": 1165,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 1140,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "tierLabel": "30-40 pax",
        "paxFrom": 30,
        "paxTo": 40,
        "basePrice": 1330,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "tierLabel": "50-90 pax",
        "paxFrom": 50,
        "paxTo": 90,
        "basePrice": 1275,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 1250,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "tierLabel": "30-40 pax",
        "paxFrom": 30,
        "paxTo": 40,
        "basePrice": 1800,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "tierLabel": "50-90 pax",
        "paxFrom": 50,
        "paxTo": 90,
        "basePrice": 1750,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "tierLabel": "100+ pax",
        "paxFrom": 100,
        "paxTo": 9999,
        "basePrice": 1720,
        "priceType": "Per Head",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "tierLabel": "All regular tiers",
        "paxFrom": 50,
        "paxTo": 9999,
        "basePrice": 910,
        "priceType": "Per Head",
        "notes": "100+ may get P20/head discount per PDF"
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "tierLabel": "All regular tiers",
        "paxFrom": 50,
        "paxTo": 9999,
        "basePrice": 1010,
        "priceType": "Per Head",
        "notes": "100+ may get P20/head discount per PDF"
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "tierLabel": "30 pax",
        "paxFrom": 30,
        "paxTo": 30,
        "basePrice": 32600,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "tierLabel": "50 pax",
        "paxFrom": 50,
        "paxTo": 50,
        "basePrice": 47500,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 93000,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "tierLabel": "30 pax",
        "paxFrom": 30,
        "paxTo": 30,
        "basePrice": 38100,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "tierLabel": "50 pax",
        "paxFrom": 50,
        "paxTo": 50,
        "basePrice": 54100,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 107700,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "tierLabel": "30 pax",
        "paxFrom": 30,
        "paxTo": 30,
        "basePrice": 34250,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "tierLabel": "50 pax",
        "paxFrom": 50,
        "paxTo": 50,
        "basePrice": 48000,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 95000,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "tierLabel": "30 pax",
        "paxFrom": 30,
        "paxTo": 30,
        "basePrice": 41500,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "tierLabel": "50 pax",
        "paxFrom": 50,
        "paxTo": 50,
        "basePrice": 59250,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 115000,
        "priceType": "Fixed",
        "notes": null
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "tierLabel": "100 pax",
        "paxFrom": 100,
        "paxTo": 100,
        "basePrice": 75000,
        "priceType": "Fixed",
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "tierLabel": "150 pax",
        "paxFrom": 150,
        "paxTo": 150,
        "basePrice": 107500,
        "priceType": "Fixed",
        "notes": "Minimum 100 guests"
      }
    ],
    "Package_Rules": [
      {
        "ruleID": "RULE_RB_SLIDER_30",
        "packageID": "RS_BITES",
        "category": "Slider or Crostini",
        "paxCondition": "30-50 pax",
        "clientChoiceAllowed": "Choose 1",
        "assistantDisplay": "Show recommended 1",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_RB_SLIDER_100",
        "packageID": "RS_BITES",
        "category": "Slider or Crostini",
        "paxCondition": "100 pax",
        "clientChoiceAllowed": "Choose up to 2",
        "assistantDisplay": "Show recommended 2",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_RB_DESSERT_30",
        "packageID": "RS_BITES",
        "category": "Dessert",
        "paxCondition": "30-50 pax",
        "clientChoiceAllowed": "Choose 1",
        "assistantDisplay": "Show recommended 1",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_RB_DESSERT_100",
        "packageID": "RS_BITES",
        "category": "Dessert",
        "paxCondition": "100 pax",
        "clientChoiceAllowed": "Choose up to 2",
        "assistantDisplay": "Show recommended 2",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_RC_CANAPE",
        "packageID": "RS_COCKTAILS",
        "category": "Canape & Crostini",
        "paxCondition": "All pax",
        "clientChoiceAllowed": "Choose 4",
        "assistantDisplay": "Show curated 4",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_RC_DESSERT_30",
        "packageID": "RS_COCKTAILS",
        "category": "Dessert",
        "paxCondition": "30/50 pax",
        "clientChoiceAllowed": "Choose 1",
        "assistantDisplay": "Show recommended 1",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_RC_DESSERT_100",
        "packageID": "RS_COCKTAILS",
        "category": "Dessert",
        "paxCondition": "100 pax",
        "clientChoiceAllowed": "Choose 1-2",
        "assistantDisplay": "Show recommended 2 if budget allows",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_FULL_APP",
        "packageID": "FC_SIGNATURE;FC_FEAST",
        "category": "Appetizers",
        "paxCondition": "All pax",
        "clientChoiceAllowed": "Choose 2",
        "assistantDisplay": "Show recommended 2",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_FULL_DESSERT_30",
        "packageID": "FC_RUSTIC_B;FC_SIGNATURE",
        "category": "Dessert",
        "paxCondition": "30-50 pax",
        "clientChoiceAllowed": "Choose 1",
        "assistantDisplay": "Show recommended 1",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_FULL_DESSERT_100",
        "packageID": "FC_RUSTIC_B;FC_SIGNATURE",
        "category": "Dessert",
        "paxCondition": "100 pax",
        "clientChoiceAllowed": "Choose up to 2",
        "assistantDisplay": "Show recommended 2 if appropriate",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": null
      },
      {
        "ruleID": "RULE_PASTA",
        "packageID": "Multiple",
        "category": "Pasta",
        "paxCondition": "All pax",
        "clientChoiceAllowed": "Choose 1",
        "assistantDisplay": "Show 1 recommended pasta",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": "Truffle options +P30/head"
      },
      {
        "ruleID": "RULE_STANDARD_DESSERT",
        "packageID": "ST_A;ST_B",
        "category": "Dessert",
        "paxCondition": "All pax",
        "clientChoiceAllowed": "Choose 1",
        "assistantDisplay": "Show 1 recommended dessert",
        "proposalDisplay": "Show recommended + alternatives",
        "notes": "Peach & Mango Parfait indoor only"
      }
    ],
    "Package_Scoring": [
      {
        "eventTheme": "Birthdays & Social Celebrations",
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "score": 1,
        "recommendationLabel": "Best Fit",
        "conditionUseWhen": "Family/social buffet, 30 pax+",
        "reason": "Strong all-around family/social buffet with premium feel"
      },
      {
        "eventTheme": "Birthdays & Social Celebrations",
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Premium milestone or higher budget",
        "reason": "More premium and varied"
      },
      {
        "eventTheme": "Birthdays & Social Celebrations",
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Kiddie-forward or budget-conscious family celebration",
        "reason": "Crowd-friendly and casual"
      },
      {
        "eventTheme": "Birthdays & Social Celebrations",
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Light/kiddie station preference",
        "reason": "Easy crowd favorites for relaxed kiddie parties"
      },
      {
        "eventTheme": "Corporate Events",
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "score": 1,
        "recommendationLabel": "Best Fit",
        "conditionUseWhen": "Corporate lunch/dinner, 30 pax+",
        "reason": "Best balance of premium and complete dining"
      },
      {
        "eventTheme": "Corporate Events",
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Budget moderate / simpler buffet",
        "reason": "Simpler buffet with pork roast direction"
      },
      {
        "eventTheme": "Corporate Events",
        "packageID": "RS_LITE",
        "packageName": "Rustic Lite",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Short-format large event, 100 pax+",
        "reason": "Streamlined option for shorter programs"
      },
      {
        "eventTheme": "Corporate Events",
        "packageID": "CUSTOM_REVIEW",
        "packageName": "Custom Review",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Large volume / budget stretch",
        "reason": "Large corporate volume may allow custom structure"
      },
      {
        "eventTheme": "Cocktail & Networking Events",
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "score": 1,
        "recommendationLabel": "Best Fit",
        "conditionUseWhen": "Cocktail-style or mingling format",
        "reason": "Designed for standing, networking and easy eating"
      },
      {
        "eventTheme": "Cocktail & Networking Events",
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Natalia's Signature Graze",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "More abundant grazing direction",
        "reason": "Premium grazing table for mingling events"
      },
      {
        "eventTheme": "Cocktail & Networking Events",
        "packageID": "RS_LITE",
        "packageName": "Rustic Lite",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Short-format large event, 100 pax+",
        "reason": "Streamlined option for quick turnover"
      },
      {
        "eventTheme": "Weddings",
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "score": 1,
        "recommendationLabel": "Best Fit",
        "conditionUseWhen": "Wedding reception with full meal",
        "reason": "Premium but still approachable wedding menu"
      },
      {
        "eventTheme": "Weddings",
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Budget moderate / classic buffet",
        "reason": "Complete full-service wedding-friendly option"
      },
      {
        "eventTheme": "Weddings",
        "packageID": "FC_FEAST",
        "packageName": "Rustic Feast",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Budget high / elevated reception",
        "reason": "Most elevated full-service option"
      },
      {
        "eventTheme": "Weddings",
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "score": 2,
        "recommendationLabel": "Alternative",
        "conditionUseWhen": "Cocktail hour or standing reception",
        "reason": "Best for pre-reception cocktails or light wedding reception"
      }
    ],
    "Menu_By_Package": [
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Slider",
        "rule": "Included",
        "menuItemsSelections": "Cheeseburger Sliders with Bacon & Chips",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": "Recommended for kiddie parties"
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Main Entrees",
        "rule": "All included",
        "menuItemsSelections": "Signature Beef Salpicao; American Style Pork BBQ Ribs; Chicken Tenders with Glazed Doughnut Poppers",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Mighty Meaty Bolognese",
        "alternative": "Creamed Fettuccine",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Rice",
        "rule": "Included",
        "menuItemsSelections": "Steamed Rice",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Dessert",
        "rule": "Included",
        "menuItemsSelections": "Salted Gooey Brownie Tart",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Refreshments",
        "rule": "Included",
        "menuItemsSelections": "Purified Drinking Water; Iced Tea until supplies last",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Salad",
        "rule": "Choose 1",
        "menuItemsSelections": "Rustic Caesar Salad; Summer Salad; Greek Salad; Asian Soba Slaw Salad",
        "upgradePrice": null,
        "recommendedDefault": "Summer Salad",
        "alternative": "Rustic Caesar Salad",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuItemsSelections": "Chicken Kebab with Tzatziki Dip; Traditional Roast Chicken; Chicken Teriyaki; Jamaican Jerk Chicken; Chicken Inasal; Creamy Herb Garlic Chicken",
        "upgradePrice": null,
        "recommendedDefault": "Chicken Kebab with Tzatziki Dip",
        "alternative": "Traditional Roast Chicken",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Seafood",
        "rule": "Choose 1",
        "menuItemsSelections": "Seared Norwegian Salmon with Mushroom Cream Sauce; Shrimp & Chorizo Al Ajillo",
        "upgradePrice": null,
        "recommendedDefault": "Seared Norwegian Salmon with Mushroom Cream Sauce",
        "alternative": "Shrimp & Chorizo Al Ajillo",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Beef",
        "rule": "Choose 1",
        "menuItemsSelections": "Signature Beef Salpicao; Classic U.S. Roast Beef",
        "upgradePrice": null,
        "recommendedDefault": "Signature Beef Salpicao",
        "alternative": "Classic U.S. Roast Beef",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Signature Roast",
        "rule": "Included",
        "menuItemsSelections": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Mighty Meaty Bolognese",
        "alternative": "Creamed Fettuccine",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuItemsSelections": "Vanilla Crème Brulee Pots; Tiramisu; Luxe Belgian Chocolate Mousse; Salted Gooey Brownie Tart",
        "upgradePrice": null,
        "recommendedDefault": "Vanilla Crème Brulee Pots",
        "alternative": "Tiramisu",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuItemsSelections": "Spanish Meatballs; Mini Chicken Kebab Skewers with Tzatziki Dip; Mini Chicken Inasal Skewers; Egg Salad Canape; Chicken Salad Slider; Roast Beef Crostini; Brie & Berry Jam Crostini; Caprese Crostini; Tuna Tartlet; Smoked Salmon Mousse Tartlet; Duck Confit Tartlet; Duck Confit Tartlet & Foie Gras",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "recommendedDefault": "Roast Beef Crostini + Mini Chicken Kebab Skewers",
        "alternative": "Egg Salad Canape + Brie & Berry Jam Crostini",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Salad",
        "rule": "Choose 1",
        "menuItemsSelections": "Rustic Caesar Salad; Summer Salad; Greek Salad; Asian Soba Slaw Salad",
        "upgradePrice": null,
        "recommendedDefault": "Summer Salad",
        "alternative": "Greek Salad",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuItemsSelections": "Chicken Kebab with Tzatziki Dip; Traditional Roast Chicken; Chicken Teriyaki; Jamaican Jerk Chicken; Chicken Inasal; Creamy Herb Garlic Chicken",
        "upgradePrice": null,
        "recommendedDefault": "Creamy Herb Garlic Chicken",
        "alternative": "Chicken Kebab with Tzatziki Dip",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Seafood",
        "rule": "Choose 1",
        "menuItemsSelections": "Seared Norwegian Salmon with Mushroom Cream Sauce; Shrimp & Chorizo Al Ajillo",
        "upgradePrice": null,
        "recommendedDefault": "Shrimp & Chorizo Al Ajillo",
        "alternative": "Seared Norwegian Salmon with Mushroom Cream Sauce",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Truffle Cream Fettuccine",
        "alternative": "Homemade Pesto Pasta",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Beef",
        "rule": "Choose 1",
        "menuItemsSelections": "Signature Beef Salpicao; Classic U.S. Roast Beef",
        "upgradePrice": null,
        "recommendedDefault": "Signature Beef Salpicao",
        "alternative": "Classic U.S. Roast Beef",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Signature Roast",
        "rule": "Included",
        "menuItemsSelections": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuItemsSelections": "Vanilla Crème Brulee Pots; Tiramisu; Luxe Belgian Chocolate Mousse; Salted Gooey Brownie Tart",
        "upgradePrice": null,
        "recommendedDefault": "Vanilla Crème Brulee Pots",
        "alternative": "Luxe Belgian Chocolate Mousse",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Charcuterie",
        "rule": "Included",
        "menuItemsSelections": "2 kinds of Artisanal Cheese; 2 Premium Charcuterie Cuts; Fresh Berries",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Welcome Drink",
        "rule": "Included",
        "menuItemsSelections": "1 Round Tropical Sunshine Fruit Juice",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuItemsSelections": "Spanish Meatballs; Mini Chicken Kebab Skewers; Mini Chicken Inasal Skewers; Egg Salad Canape; Chicken Salad Slider; Roast Beef Crostini; Brie & Berry Jam Crostini; Caprese Crostini; Tuna Tartlet; premium tartlets",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "recommendedDefault": "Spanish Meatballs + Brie & Berry Jam Crostini",
        "alternative": "Egg Salad Canape + Tuna Tartlet",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Soup",
        "rule": "Choose 1",
        "menuItemsSelections": "Roasted Pumpkin Soup; Potato & Leek Soup; Mushroom Soup; Tomato Soup",
        "upgradePrice": null,
        "recommendedDefault": "Roasted Pumpkin Soup",
        "alternative": "Mushroom Soup",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Salad",
        "rule": "Choose 1",
        "menuItemsSelections": "Rustic Caesar Salad; Summer Salad; Greek Salad; Asian Soba Slaw Salad",
        "upgradePrice": null,
        "recommendedDefault": "Caesar Salad",
        "alternative": "Summer Salad",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuItemsSelections": "Chicken Kebab with Tzatziki Dip; Traditional Roast Chicken; Chicken Teriyaki; Jamaican Jerk Chicken; Chicken Inasal; Creamy Herb Garlic Chicken",
        "upgradePrice": null,
        "recommendedDefault": "Chicken Kebab with Tzatziki Dip",
        "alternative": "Creamy Herb Garlic Chicken",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Mushroom Pasta Rigatoni",
        "alternative": "Mushroom Pasta Rigatoni",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Main Entrees",
        "rule": "All included",
        "menuItemsSelections": "Signature Beef Salpicao; 6-hr Slow Roasted Pork Belly; Three Cheese Baked Prawns",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Rustic Tartlets",
        "rule": "Included",
        "menuItemsSelections": "Fruit Tartlet; Chocolate Mousse Tartlet with Cardamom",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Salad",
        "rule": "Included",
        "menuItemsSelections": "Mesclun Greens with Balsamic Dressing",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Beef",
        "rule": "Choose 1",
        "menuItemsSelections": "Braised Beef Short Ribs; Signature Beef Salpicao",
        "upgradePrice": null,
        "recommendedDefault": "Signature Beef Salpicao",
        "alternative": "Braised Beef Short Ribs",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuItemsSelections": "Traditional Roast Chicken; Chicken Teriyaki; Jamaican Jerk Chicken; Chicken Inasal; Classic Chicken BBQ; Creamy Herb Garlic Chicken",
        "upgradePrice": null,
        "recommendedDefault": "Chicken Inasal",
        "alternative": "Chicken Teriyaki",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Fish",
        "rule": "Included",
        "menuItemsSelections": "Golden Cream Dory Fillet with Tartar Sauce",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Mighty Meaty Bolognese",
        "alternative": "Creamed Fettucine",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Sides",
        "rule": "Included",
        "menuItemsSelections": "Steamed Rice; Homemade Mashed Potatoes",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuItemsSelections": "Leche Flan; Creamy Cathedral Window Jelly; Double Chocolate Belgian Brownie Bites; Peach & Mango Parfait",
        "upgradePrice": null,
        "recommendedDefault": "Leche Flan",
        "alternative": "Creamy Cathedral Window Jelly",
        "notes": "Peach & Mango Parfait recommended indoors only"
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Salad",
        "rule": "Included",
        "menuItemsSelections": "Mesclun Greens with Balsamic Dressing",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Beef",
        "rule": "Choose 1",
        "menuItemsSelections": "Braised Beef Short Ribs; Signature Beef Salpicao",
        "upgradePrice": null,
        "recommendedDefault": "Signature Beef Salpicao",
        "alternative": "Braised Beef Short Ribs",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuItemsSelections": "Traditional Roast Chicken; Chicken Teriyaki; Jamaican Jerk Chicken; Chicken Inasal; Classic Chicken BBQ; Creamy Herb Garlic Chicken",
        "upgradePrice": null,
        "recommendedDefault": "Chicken Inasal",
        "alternative": "Classic Chicken BBQ",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Fish",
        "rule": "Included",
        "menuItemsSelections": "Golden Cream Dory Fillet with Tartar Sauce",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Creamed Fettuccine",
        "alternative": "Musroom Pasta Rigatoni",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Signature Roast",
        "rule": "Included",
        "menuItemsSelections": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuItemsSelections": "Leche Flan; Creamy Cathedral Window Jelly; Double Chocolate Belgian Brownie Bites; Peach & Mango Parfait",
        "upgradePrice": null,
        "recommendedDefault": "Double Chocolate Belgian Brownie Bites",
        "alternative": "Leche Flan",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuItemsSelections": "Croissant Petite Platter; Chicken Tenders & Glazed Doughnut Poppers; Mini Hash Browns; Signature Beef Salpicao; Tropical Fruit Kebab; Bottled Water",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Slider or Crostini",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuItemsSelections": "Cheeseburger Sliders; Chunky Chicken & Egg Salad Sliders; Roast Beef Crostini; Brie & Berry Jam Crostini",
        "upgradePrice": null,
        "recommendedDefault": "Cheeseburger Sliders",
        "alternative": "Chunky Chicken & Egg Salad Sliders",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto Pasta; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Mighty Meaty Bolognese",
        "alternative": "Mushroom Pasta Rigatoni",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuItemsSelections": "Salted Gooey Brownie Tart; Vanilla Creme Brulee Pots; Tiramisu; Luxe Chocolate Mousse",
        "upgradePrice": null,
        "recommendedDefault": "Salted Gooey Brownie Tart",
        "alternative": "Tiramisu",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuItemsSelections": "Spanish Meatballs; Mini Chicken Kebab Skewers; Mini Chicken Inasal Skewers; Egg Salad Canape; Chicken Salad Slider; Roast Beef Crostini; Brie & Berry Jam Crostini; Caprese Crostini; Tuna Tartlet; Smoked Salmon Mousse Tartlet; Duck Confit Tartlet; Duck Confit Tartlet & Foie Gras",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "recommendedDefault": "Roast Beef Crostini; Mini Chicken Kebab; Brie & Berry Jam; Egg Salad Canape",
        "alternative": "Spanish Meatballs; Chicken Salad Slider; Caprese Crostini; Tuna Tartlet",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Bites",
        "rule": "Both included",
        "menuItemsSelections": "Signature Beef Salpicao; Pork Boulangere",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto Pasta; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Truffle Cream Fettuccine",
        "alternative": "Homemade Pesto Pasta",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Dessert",
        "rule": "30/50 choose 1; 100 choose 1-2",
        "menuItemsSelections": "Salted Gooey Brownie Tart; Vanilla Creme Brulee Pots; Tiramisu",
        "upgradePrice": null,
        "recommendedDefault": "Vanilla Crème Brulee Pots",
        "alternative": "Salted Gooey Brownie Tart",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Refreshments",
        "rule": "Included",
        "menuItemsSelections": "Sparkling Water & Soda; Still Water; Citrus-Infused Water",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuItemsSelections": "Caprese; 4 Artisanal Cheeses; 3 Premium Charcuterie Cuts",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuItemsSelections": "Tropical Fruit Kebab; Grapes & Berries; Olives; Crackers",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Bites",
        "rule": "Included",
        "menuItemsSelections": "Egg Salad Canape; Roast Beef Crostini with Chimichurri; Cheeseburger Sliders; Mini Chicken Kebab Skewers with Tzatziki Dip",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Sweet Treat",
        "rule": "Included",
        "menuItemsSelections": "Belgian Chocolate Brownie Bites",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuItemsSelections": "Caprese; 4 Artisanal Cheeses; 3 Premium Charcuterie Cuts",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuItemsSelections": "Tropical Fruit Kebab; Grapes & Berries; Olives; Crackers",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Bites",
        "rule": "All included",
        "menuItemsSelections": "Egg Salad Canape; Roast Beef Crostini with Chimichurri; Mini Chicken Kebab Skewers; Signature Beef Salpicao",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuItemsSelections": "Mighty Meaty Bolognese; Creamed Fettuccine; Homemade Pesto Pasta; Mushroom Pasta Rigatoni; Truffle Cream Fettuccine",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "recommendedDefault": "Homemade Pesto Pasta",
        "alternative": "Truffle Cream Fettuccine",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Sweet Treat",
        "rule": "Included",
        "menuItemsSelections": "Belgian Double Chocolate Brownie Bites",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": null
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuItemsSelections": "Petite Croissant Platter; Egg Salad Canape; Double Chocolate Brownie Bites; Spanish Meatballs; Mini Chicken Kebab; Mini Cheese & Fruit Spread; 4 Artisanal Cheeses; 1 Premium Charcuterie Cut; Fruits & Berries; Citrus-Infused Water",
        "upgradePrice": null,
        "recommendedDefault": "Yes",
        "alternative": "None - Default",
        "notes": "Minimum 100 guests"
      }
    ],
    "Menu_Database": [
      {
        "dishItem": "Signature Beef Salpicao",
        "category": "Beef / Bite",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Wedding; Social; Kiddie",
        "audience": "All",
        "premiumLevel": 5,
        "popularity": 10,
        "defaultReco": "Yes",
        "notes": "Core NRK signature item"
      },
      {
        "dishItem": "Classic U.S. Roast Beef",
        "category": "Beef",
        "serviceFit": "Full Service; Add-on",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Premium/classic alternative"
      },
      {
        "dishItem": "Braised Beef Short Ribs",
        "category": "Beef",
        "serviceFit": "Standard Catering",
        "bestEvents": "Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "6-hr Slow Roasted Pork Belly",
        "category": "Pork Roast",
        "serviceFit": "Full Service",
        "bestEvents": "Wedding; Social; Corporate",
        "audience": "All",
        "premiumLevel": 5,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Included in Rustic B/Signature/Feast/Standard B"
      },
      {
        "dishItem": "American Style Pork BBQ Ribs",
        "category": "Pork",
        "serviceFit": "Rustic A",
        "bestEvents": "Kiddie; Social",
        "audience": "Families",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Pork Boulangere",
        "category": "Bite / Carving",
        "serviceFit": "Stations; Add-on",
        "bestEvents": "Corporate Cocktails; Social",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Three Cheese Baked Prawns",
        "category": "Seafood",
        "serviceFit": "Rustic Feast",
        "bestEvents": "Wedding; Premium Social",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Feast included main"
      },
      {
        "dishItem": "Seared Norwegian Salmon with Mushroom Cream Sauce",
        "category": "Seafood",
        "serviceFit": "Full Service",
        "bestEvents": "Corporate; Wedding",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Premium profile"
      },
      {
        "dishItem": "Shrimp & Chorizo Al Ajillo",
        "category": "Seafood",
        "serviceFit": "Full Service",
        "bestEvents": "Social; Corporate",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Rustic/adult flavor"
      },
      {
        "dishItem": "Golden Cream Dory Fillet with Tartar Sauce",
        "category": "Fish",
        "serviceFit": "Standard Catering",
        "bestEvents": "Corporate; Social",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Creamy Herb Garlic Chicken",
        "category": "Chicken",
        "serviceFit": "Full Service; Standard",
        "bestEvents": "Corporate; Wedding; Social",
        "audience": "All",
        "premiumLevel": 4,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Safe premium crowd-pleaser"
      },
      {
        "dishItem": "Chicken Inasal",
        "category": "Chicken",
        "serviceFit": "Full Service; Standard",
        "bestEvents": "Social; Family; Kiddie",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Familiar Filipino favorite"
      },
      {
        "dishItem": "Chicken Kebab with Tzatziki Dip",
        "category": "Chicken",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Social; Cocktails",
        "audience": "All",
        "premiumLevel": 4,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Works well for cocktails"
      },
      {
        "dishItem": "Traditional Roast Chicken",
        "category": "Chicken",
        "serviceFit": "Full Service; Standard",
        "bestEvents": "Social; Corporate",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Chicken Teriyaki",
        "category": "Chicken",
        "serviceFit": "Full Service; Standard",
        "bestEvents": "Kiddie; Social; Corporate",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Jamaican Jerk Chicken",
        "category": "Chicken",
        "serviceFit": "Full Service; Standard",
        "bestEvents": "Social; Corporate",
        "audience": "Adults",
        "premiumLevel": 3,
        "popularity": 6,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Classic Chicken BBQ",
        "category": "Chicken",
        "serviceFit": "Standard Catering",
        "bestEvents": "Kiddie; Social",
        "audience": "Families",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Chicken Tenders with Glazed Doughnut Poppers",
        "category": "Chicken / Kiddie",
        "serviceFit": "Rustic A; Rustic Bites",
        "bestEvents": "Kiddie Party",
        "audience": "Kids",
        "premiumLevel": 1,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Kid-friendly"
      },
      {
        "dishItem": "Rustic Caesar Salad",
        "category": "Salad",
        "serviceFit": "Full Service",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Summer Salad",
        "category": "Salad",
        "serviceFit": "Full Service",
        "bestEvents": "Social; Wedding",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Greek Salad",
        "category": "Salad",
        "serviceFit": "Full Service",
        "bestEvents": "Corporate; Wedding; Social",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Fresh and premium"
      },
      {
        "dishItem": "Asian Soba Slaw Salad",
        "category": "Salad",
        "serviceFit": "Full Service",
        "bestEvents": "Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Mesclun Greens with Balsamic Dressing",
        "category": "Salad",
        "serviceFit": "Standard Catering",
        "bestEvents": "Corporate; Social",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Mighty Meaty Bolognese",
        "category": "Pasta",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Kiddie; Social; Corporate",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Good family/kiddie option"
      },
      {
        "dishItem": "Creamed Fettuccine",
        "category": "Pasta",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Social; Corporate",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Homemade Pesto Pasta",
        "category": "Pasta",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Mushroom Pasta Rigatoni",
        "category": "Pasta",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Wedding; Social",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 7,
        "defaultReco": null,
        "notes": "Truffle upgrade available"
      },
      {
        "dishItem": "Truffle Cream Fettuccine",
        "category": "Pasta",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Wedding; Premium Social",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "+P30/head"
      },
      {
        "dishItem": "Vanilla Crème Brulee Pots",
        "category": "Dessert",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Wedding; Social",
        "audience": "All",
        "premiumLevel": 5,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Premium plated/pot dessert feel"
      },
      {
        "dishItem": "Tiramisu",
        "category": "Dessert",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Wedding; Social",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Adult dessert"
      },
      {
        "dishItem": "Luxe Belgian Chocolate Mousse",
        "category": "Dessert",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Social",
        "audience": "All",
        "premiumLevel": 4,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Salted Gooey Brownie Tart",
        "category": "Dessert",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Kiddie; Social; Corporate",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": "Crowd favorite"
      },
      {
        "dishItem": "Leche Flan",
        "category": "Dessert",
        "serviceFit": "Standard Catering",
        "bestEvents": "Social; Family",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Familiar Filipino dessert"
      },
      {
        "dishItem": "Creamy Cathedral Window Jelly",
        "category": "Dessert",
        "serviceFit": "Standard Catering",
        "bestEvents": "Social; Family",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Double Chocolate Belgian Brownie Bites",
        "category": "Dessert",
        "serviceFit": "Standard; Stations; Lite",
        "bestEvents": "Kiddie; Social; Corporate",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Peach & Mango Parfait",
        "category": "Dessert",
        "serviceFit": "Standard Catering",
        "bestEvents": "Social; Corporate",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": "Indoor recommended"
      },
      {
        "dishItem": "Spanish Meatballs",
        "category": "Canape / Bite",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Corporate Cocktails; Social",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Mini Chicken Inasal Skewers",
        "category": "Canape / Bite",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Social; Corporate; Family",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Egg Salad Canape",
        "category": "Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Social; Corporate",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Chicken Salad Slider",
        "category": "Canape / Slider",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Social; Corporate",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Roast Beef Crostini",
        "category": "Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Corporate; Wedding; Social",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Brie & Berry Jam Crostini",
        "category": "Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Caprese Crostini",
        "category": "Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Tuna Tartlet",
        "category": "Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Corporate; Social",
        "audience": "Adults",
        "premiumLevel": 4,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Smoked Salmon Mousse Tartlet",
        "category": "Premium Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Wedding; Corporate",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 7,
        "defaultReco": null,
        "notes": "Upgrade +P20/head"
      },
      {
        "dishItem": "Duck Confit Tartlet",
        "category": "Premium Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Premium Social; Wedding",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 6,
        "defaultReco": null,
        "notes": "Upgrade +P70/head"
      },
      {
        "dishItem": "Duck Confit Tartlet & Foie Gras",
        "category": "Premium Canape",
        "serviceFit": "Stations; Signature; Feast",
        "bestEvents": "Premium Wedding; VIP Corporate",
        "audience": "Adults",
        "premiumLevel": 5,
        "popularity": 5,
        "defaultReco": null,
        "notes": "Upgrade +P140/head"
      },
      {
        "dishItem": "Cheeseburger Sliders",
        "category": "Slider",
        "serviceFit": "Rustic Bites; Classic Graze",
        "bestEvents": "Kiddie; Social",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 9,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Chunky Chicken & Egg Salad Sliders",
        "category": "Slider",
        "serviceFit": "Rustic Bites",
        "bestEvents": "Kiddie; Social",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Croissant Petite Platter",
        "category": "Pastry",
        "serviceFit": "Rustic Bites; Rustic Lite",
        "bestEvents": "Brunch; Kiddie; Corporate Social",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Mini Hash Browns",
        "category": "Side",
        "serviceFit": "Rustic Bites",
        "bestEvents": "Kiddie; Brunch",
        "audience": "Kids",
        "premiumLevel": 1,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Tropical Fruit Kebab",
        "category": "Fruit / Add-on",
        "serviceFit": "Full Service; Stations",
        "bestEvents": "Corporate; Social; Kiddie",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": "Complimentary option for 100+ full service/stations"
      },
      {
        "dishItem": "Roasted Pumpkin Soup",
        "category": "Soup",
        "serviceFit": "Feast; Soup Add-on",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": "Yes",
        "notes": null
      },
      {
        "dishItem": "Potato & Leek Soup",
        "category": "Soup",
        "serviceFit": "Feast; Soup Add-on",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Mushroom Soup",
        "category": "Soup",
        "serviceFit": "Feast; Soup Add-on",
        "bestEvents": "Wedding; Corporate; Social",
        "audience": "All",
        "premiumLevel": 3,
        "popularity": 8,
        "defaultReco": null,
        "notes": null
      },
      {
        "dishItem": "Tomato Soup",
        "category": "Soup",
        "serviceFit": "Feast; Soup Add-on",
        "bestEvents": "Social; Corporate",
        "audience": "All",
        "premiumLevel": 2,
        "popularity": 7,
        "defaultReco": null,
        "notes": null
      }
    ],
    "Addons": [
      {
        "addOnID": "ADD_KIDDIE",
        "addOnName": "Kiddie Buffet",
        "category": "Food",
        "availableFor": "Full Service Catering",
        "pricing": "₱475/head",
        "minTiers": "Minimum 20 kids",
        "recommendFor": "Birthdays & Social Celebrations",
        "reasonTemplate": "This is helpful when you want a separate, child-friendly spread while adults enjoy the main buffet.",
        "sourceNotes": "Full service add-on"
      },
      {
        "addOnID": "ADD_MINI_GRAZE",
        "addOnName": "Mini Graze",
        "category": "Food",
        "availableFor": "Main Catering Packages",
        "pricing": "₱375/head",
        "minTiers": "Minimum 30 pax, increments of 10",
        "recommendFor": "Weddings; Corporate Events; Birthdays & Social Celebrations",
        "reasonTemplate": "A great addition to your buffet, offering light bites for guests to enjoy as they arrive before the main buffet opens.",
        "sourceNotes": "Full service add-on"
      },
      {
        "addOnID": "ADD_SOUP",
        "addOnName": "Soup Service",
        "category": "Food",
        "availableFor": "Main Catering Packages",
        "pricing": "₱110/head",
        "minTiers": "Minimum 30 pax, increments of 10",
        "recommendFor": "Corporate Events; Weddings",
        "reasonTemplate": "A warm starter helps make the meal feel more complete and elevated.",
        "sourceNotes": "Full service add-on"
      },
      {
        "addOnID": "ADD_HAM",
        "addOnName": "Ham & Pan de Sal Station",
        "category": "Food Station",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "₱9,000/50; ₱16,500/100",
        "minTiers": "50 or 100 pax",
        "recommendFor": "Birthdays & Social Celebrations; Corporate Events",
        "reasonTemplate": "A festive add-on that works well for holiday gatherings and family-style celebrations.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_PORK_BOULANGERE",
        "addOnName": "Pork Boulangere Carving Station",
        "category": "Food Station",
        "availableFor": "Rustic Stations",
        "pricing": "₱6,000/30; ₱9,000/50; ₱16,500/100",
        "minTiers": "30/50/100 pax",
        "recommendFor": "Cocktail & Networking Events; Corporate Events; Birthdays & Social Celebrations",
        "reasonTemplate": "Adds a warm carving element to a rustic station setup.",
        "sourceNotes": "Rustic station add-on"
      },
      {
        "addOnID": "ADD_ROAST_BEEF",
        "addOnName": "Classic U.S. Roast Beef Carving Station",
        "category": "Food Station",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "₱7,000/30; ₱10,000/50; ₱18,000/100",
        "minTiers": "30/50/100 pax",
        "recommendFor": "Weddings; Corporate Events; Birthdays & Social Celebrations",
        "reasonTemplate": "A strong premium upgrade when you want a classic centerpiece dish.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_PRIME_RIB",
        "addOnName": "U.S. Prime Rib Roast",
        "category": "Food Station",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "Upon request",
        "minTiers": "Manual quote",
        "recommendFor": "Weddings; Corporate Events",
        "reasonTemplate": "Best handled as a custom premium proposal due to pricing and service requirements.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_FOIE_GRAS",
        "addOnName": "On-the-Spot Foie Gras Station",
        "category": "Food Station",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "Upon request",
        "minTiers": "Venue must allow open flame",
        "recommendFor": "Weddings; Cocktail & Networking Events",
        "reasonTemplate": "A premium live-cooking station for venues that allow open-fire cooking.",
        "sourceNotes": "Requires open fire"
      },
      {
        "addOnID": "ADD_COFFEE_FULL",
        "addOnName": "Freshly Brewed Arabica Coffee",
        "category": "Beverage",
        "availableFor": "Full Service Catering",
        "pricing": "₱2,500/50; ₱5,000/100",
        "minTiers": "50/100 pax",
        "recommendFor": "Corporate Events; Weddings",
        "reasonTemplate": "Ideal when the event runs into the afternoon or includes a program.",
        "sourceNotes": "Full service price"
      },
      {
        "addOnID": "ADD_COFFEE_STATION",
        "addOnName": "Freshly Brewed Arabica Coffee",
        "category": "Beverage",
        "availableFor": "Rustic Stations",
        "pricing": "₱3,500/50; ₱7,000/100",
        "minTiers": "50/100 pax",
        "recommendFor": "Corporate Events; Cocktail & Networking Events",
        "reasonTemplate": "A simple but useful add-on for brunches and corporate gatherings.",
        "sourceNotes": "Rustic station price"
      },
      {
        "addOnID": "ADD_BEV_TUB",
        "addOnName": "Natalia's Beverage Tub",
        "category": "Beverage",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "₱4,200/30; ₱6,600/50; ₱12,600/100",
        "minTiers": "30/50/100 pax",
        "recommendFor": "All",
        "reasonTemplate": "A good non-alcoholic refreshment upgrade for mingling events.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_BEER_TUB",
        "addOnName": "Natalia's Beer Tub",
        "category": "Beverage",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "₱6,500/30; ₱9,500/50; ₱17,800/100",
        "minTiers": "30/50/100 pax",
        "recommendFor": "Corporate Events; Cocktail & Networking Events",
        "reasonTemplate": "Works well for casual after-office or laid-back celebrations.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_PIMMS",
        "addOnName": "Natalia's Pimm's Cup",
        "category": "Beverage",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "₱8,400/30; ₱13,500/50; ₱25,000/100",
        "minTiers": "30/50/100 pax",
        "recommendFor": "Weddings; Cocktail & Networking Events; Birthdays & Social Celebrations",
        "reasonTemplate": "A refreshing signature alcoholic drink for relaxed, elegant gatherings.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_WINE",
        "addOnName": "Wine Service",
        "category": "Beverage",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "Italian Red ₱1,200/bottle; French White ₱1,000/bottle; Wine Glass ₱50/glass",
        "minTiers": "Minimum 6 bottles / 12 glasses",
        "recommendFor": "Weddings; Corporate Events; Cocktail & Networking Events",
        "reasonTemplate": "A natural fit if the event includes dinner, speeches, or a more premium guest experience.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_COCKTAIL_TABLE",
        "addOnName": "Cocktail Tables with Rustic Centerpiece",
        "category": "Service / Dining",
        "availableFor": "Full Service; Rustic Stations",
        "pricing": "₱350/table",
        "minTiers": "Per table",
        "recommendFor": "Cocktail & Networking Events; Weddings",
        "reasonTemplate": "Adds comfort and structure for guests during mingling events.",
        "sourceNotes": null
      },
      {
        "addOnID": "ADD_RUSTIC_DINING",
        "addOnName": "Rustic Dining Set-up Upgrade",
        "category": "Service / Dining",
        "availableFor": "Rustic Stations",
        "pricing": "₱6,000/30; ₱9,500/50; ₱17,500/100",
        "minTiers": "30/50/100 pax",
        "recommendFor": "Weddings; Birthdays & Social Celebrations",
        "reasonTemplate": "Recommended if you want a cocktail/grazing package but guests still need proper dining tables and chairs.",
        "sourceNotes": "Rustic station dining upgrade"
      },
      {
        "addOnID": "ADD_LECHON_SERVICE",
        "addOnName": "Lechon Service",
        "category": "Service",
        "availableFor": "Full Service Catering",
        "pricing": 1500,
        "minTiers": "Max 2 lechon",
        "recommendFor": "Birthdays & Social Celebrations",
        "reasonTemplate": "Useful if client is bringing lechon and wants proper service support.",
        "sourceNotes": "Full service add-on"
      }
    ],
    "Dish_Recommendations": [
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Appetizer",
        "recommendedDish1": "Roast Beef Crostini",
        "recommendedDish2": "Egg Salad Canape",
        "why": "Offers a refined selection that's easy for guests to enjoy while mingling."
      },
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Salad",
        "recommendedDish1": "Greek Salad",
        "recommendedDish2": "Summer Salad",
        "why": "Fresh, vibrant choices that balance the richness of the main dishes."
      },
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Chicken",
        "recommendedDish1": "Creamy Herb Garlic Chicken",
        "recommendedDish2": "Chicken Kebab with Tzatziki Dip",
        "why": "Well-loved dishes that appeal to a wide range of guests."
      },
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Seafood",
        "recommendedDish1": "Seared Norwegian Salmon",
        "recommendedDish2": "Shrimp & Chorizo Al Ajillo",
        "why": "Premium seafood selections suited for business and formal occasions."
      },
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Beef",
        "recommendedDish1": "Signature Beef Salpicao",
        "recommendedDish2": "Classic U.S. Roast Beef",
        "why": "Our signature beef selections and consistent crowd favorites."
      },
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Pasta",
        "recommendedDish1": "Truffle Cream Fettuccine",
        "recommendedDish2": "Mighty Meaty Bolognese",
        "why": "Adds a more elevated touch while remaining familiar and satisfying."
      },
      {
        "recommendationProfile": "Corporate Premium Full Service",
        "category": "Dessert",
        "recommendedDish1": "Vanilla Crème Brûlée Pots",
        "recommendedDish2": "Tiramisu",
        "why": "Elegant desserts that finish the meal on a sophisticated note."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Appetizer",
        "recommendedDish1": "Roast Beef Crostini",
        "recommendedDish2": "Brie & Berry Jam Crostini",
        "why": "A refined combination that's ideal for welcoming guests."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Salad",
        "recommendedDish1": "Greek Salad",
        "recommendedDish2": "Summer Salad",
        "why": "Light and refreshing selections that complement cocktail-style dining."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Chicken",
        "recommendedDish1": "Chicken Kebab with Tzatziki Dip",
        "recommendedDish2": "Creamy Herb Garlic Chicken",
        "why": "Flavorful options that are easy to enjoy during cocktail receptions."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Seafood",
        "recommendedDish1": "Seared Norwegian Salmon",
        "recommendedDish2": "Shrimp & Chorizo Al Ajillo",
        "why": "Premium seafood that's well suited for cocktail-style entertaining."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Beef",
        "recommendedDish1": "Signature Beef Salpicao",
        "recommendedDish2": "Classic U.S. Roast Beef",
        "why": "Hearty favorites that provide a satisfying balance to lighter bites."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Pasta",
        "recommendedDish1": "Truffle Cream Fettuccine",
        "recommendedDish2": "Mighty Meaty Bolognese",
        "why": "A well-balanced pasta course with both premium and familiar flavors."
      },
      {
        "recommendationProfile": "Wedding Full Service",
        "category": "Dessert",
        "recommendedDish1": "Tiramisu",
        "recommendedDish2": "Vanilla Crème Brûlée Pots",
        "why": "Classic desserts that are consistently popular with adult guests."
      },
      {
        "recommendationProfile": "Social Family Full Service",
        "category": "Salad",
        "recommendedDish1": "Rustic Caesar Salad",
        "recommendedDish2": "Summer Salad",
        "why": "Familiar salads that appeal to a wide range of guests."
      },
      {
        "recommendationProfile": "Social Family Full Service",
        "category": "Chicken",
        "recommendedDish1": "Chicken Kebab with Tzatziki Dip",
        "recommendedDish2": "Chicken Inasal",
        "why": "A balance of international and familiar local flavors."
      },
      {
        "recommendationProfile": "Social Family Full Service",
        "category": "Seafood",
        "recommendedDish1": "Seared Norwegian Salmon",
        "recommendedDish2": "Shrimp & Chorizo Al Ajillo",
        "why": "Flavorful seafood choices that work well for adult celebrations."
      },
      {
        "recommendationProfile": "Social Family Full Service",
        "category": "Beef",
        "recommendedDish1": "Signature Beef Salpicao",
        "recommendedDish2": "Classic U.S. Roast Beef",
        "why": "Signature beef dishes that remain among our most requested selections."
      },
      {
        "recommendationProfile": "Social Family Full Service",
        "category": "Pasta",
        "recommendedDish1": "Mighty Meaty Bolognese",
        "recommendedDish2": "Creamed Fettuccine",
        "why": "Comforting pasta dishes that guests of all ages enjoy."
      },
      {
        "recommendationProfile": "Social Family Full Service",
        "category": "Dessert",
        "recommendedDish1": "Vanilla Crème Brûlée Pots",
        "recommendedDish2": "Salted Gooey Brownie Tart",
        "why": "A combination of classic elegance and familiar comfort."
      },
      {
        "recommendationProfile": "Kiddie Party",
        "category": "Slider / Base",
        "recommendedDish1": "Cheeseburger Sliders",
        "recommendedDish2": "—",
        "why": "A fun, easy-to-eat favorite for children."
      },
      {
        "recommendationProfile": "Kiddie Party",
        "category": "Main",
        "recommendedDish1": "Chicken Tenders with Glazed Doughnut Poppers",
        "recommendedDish2": "—",
        "why": "A playful combination that's always popular with younger guests."
      },
      {
        "recommendationProfile": "Kiddie Party",
        "category": "Pasta",
        "recommendedDish1": "Mighty Meaty Bolognese",
        "recommendedDish2": "Creamed Fettuccine",
        "why": "Familiar pasta dishes that children and adults alike enjoy."
      },
      {
        "recommendationProfile": "Kiddie Party",
        "category": "Dessert",
        "recommendedDish1": "Salted Gooey Brownie Tart",
        "recommendedDish2": "—",
        "why": "A simple, well-loved dessert that's easy to serve."
      },
      {
        "recommendationProfile": "Corporate Cocktails",
        "category": "Canape",
        "recommendedDish1": "Roast Beef Crostini",
        "recommendedDish2": "Mini Chicken Kebab Skewers",
        "why": "Easy-to-enjoy bites that are perfect for standing receptions."
      },
      {
        "recommendationProfile": "Corporate Cocktails",
        "category": "Canape",
        "recommendedDish1": "Brie & Berry Jam Crostini",
        "recommendedDish2": "Tuna Tartlet",
        "why": "Adds variety and a more premium touch to the cocktail spread."
      },
      {
        "recommendationProfile": "Corporate Cocktails",
        "category": "Bite",
        "recommendedDish1": "Signature Beef Salpicao",
        "recommendedDish2": "Pork Boulangere",
        "why": "More substantial bites that keep guests satisfied throughout the event."
      },
      {
        "recommendationProfile": "Corporate Cocktails",
        "category": "Pasta",
        "recommendedDish1": "Truffle Cream Fettuccine",
        "recommendedDish2": "Homemade Pesto Pasta",
        "why": "Complements cocktail-style receptions with a hearty pasta option."
      },
      {
        "recommendationProfile": "Corporate Cocktails",
        "category": "Dessert",
        "recommendedDish1": "Vanilla Crème Brûlée Pots",
        "recommendedDish2": "Tiramisu",
        "why": "Sophisticated desserts that are ideal for adult gatherings."
      },
      {
        "recommendationProfile": "Grazing / Light Social",
        "category": "Grazing",
        "recommendedDish1": "Cheese & Charcuterie",
        "recommendedDish2": "Roast Beef Crostini",
        "why": "Creates a generous grazing experience with a balance of flavors and textures."
      },
      {
        "recommendationProfile": "Grazing / Light Social",
        "category": "Bites",
        "recommendedDish1": "Mini Chicken Kebab Skewers",
        "recommendedDish2": "Signature Beef Salpicao",
        "why": "Adds heartier selections while maintaining a cocktail-style dining experience."
      }
    ],
    "Response_Library": [
      {
        "responseID": "INTRO",
        "useCase": "Opening",
        "assistantCopy": "Hi! I’m Natalia’s Event Planner. I’ll help you find the most suitable catering direction based on your event type, location, and guest count."
      },
      {
        "responseID": "RECO_HEADER",
        "useCase": "Recommendation intro",
        "assistantCopy": "Based on what you shared, I’d recommend two possible directions for your event."
      },
      {
        "responseID": "NO_PDF_NOTE",
        "useCase": "Menu exposure",
        "assistantCopy": "Rather than overwhelming you with every menu option, I’ve shortlisted a menu combination that I think will suit your event best. Other selections can still be discussed in the formal proposal."
      },
      {
        "responseID": "CORP_LUNCH",
        "useCase": "Corporate lunch reco",
        "assistantCopy": "For a corporate lunch or dinner, I’d lean toward a full-service buffet with a polished but familiar menu. This gives your guests a complete dining experience while keeping the flow smooth for meetings, programs, or client-facing events."
      },
      {
        "responseID": "CORP_COCKTAILS",
        "useCase": "Corporate cocktails reco",
        "assistantCopy": "Since your guests will likely be mingling, I’d recommend a cocktail-style spread rather than a traditional buffet. This makes the food easier to enjoy while guests are networking or moving around."
      },
      {
        "responseID": "WEDDING",
        "useCase": "Wedding reco",
        "assistantCopy": "For a wedding reception, I’d keep the recommendation within full-service catering so the experience feels complete and properly supported with dining setup, buffet service, and guest assistance."
      },
      {
        "responseID": "KIDDIE",
        "useCase": "Kiddie reco",
        "assistantCopy": "For a kiddie party, I’d recommend a menu that works for both children and adults, with familiar dishes and easy-to-enjoy bites."
      },
      {
        "responseID": "STRETCH",
        "useCase": "Budget stretch",
        "assistantCopy": "Thank you for sharing your preferred investment. Based on the event type, guest count, and location, this range may be challenging for the experience described. We don’t want to recommend a package that won’t meet expectations, but our team can review options if your budget has some flexibility."
      },
      {
        "responseID": "ADDON_INTRO",
        "useCase": "Add-on intro",
        "assistantCopy": "You may also want to consider these add-ons, depending on your program and guest flow."
      },
      {
        "responseID": "HULK_HANDOFF",
        "useCase": "Formal proposal button copy",
        "assistantCopy": "Continue to Formal Proposal"
      }
    ],
    "Hulk_Form_Mapping": [
      {
        "fieldName": "Event Type",
        "sourceFromPlanner": "Q1 selected event type",
        "uRLParameter": "event_type",
        "hiddenOrVisible": "Hidden or Visible",
        "notes": "Can prefill Hulk field"
      },
      {
        "fieldName": "Location",
        "sourceFromPlanner": "Q2 selected location",
        "uRLParameter": "location",
        "hiddenOrVisible": "Hidden or Visible",
        "notes": null
      },
      {
        "fieldName": "Guest Count",
        "sourceFromPlanner": "Q3 pax",
        "uRLParameter": "pax",
        "hiddenOrVisible": "Hidden or Visible",
        "notes": null
      },
      {
        "fieldName": "Best Fit Package",
        "sourceFromPlanner": "Recommendation result",
        "uRLParameter": "best_fit",
        "hiddenOrVisible": "Hidden",
        "notes": "Sales team sees recommendation"
      },
      {
        "fieldName": "Alternative Package",
        "sourceFromPlanner": "Recommendation result",
        "uRLParameter": "alternative",
        "hiddenOrVisible": "Hidden",
        "notes": null
      },
      {
        "fieldName": "Suggested Menu",
        "sourceFromPlanner": "Generated menu combination",
        "uRLParameter": "suggested_menu",
        "hiddenOrVisible": "Hidden / long text",
        "notes": "May need textarea"
      },
      {
        "fieldName": "Suggested Add-ons",
        "sourceFromPlanner": "Generated add-ons",
        "uRLParameter": "addons",
        "hiddenOrVisible": "Hidden / long text",
        "notes": null
      },
      {
        "fieldName": "Source",
        "sourceFromPlanner": "Static value",
        "uRLParameter": "source",
        "hiddenOrVisible": "Hidden",
        "notes": "Event Planner"
      }
    ],
    "Settings": [
      {
        "setting": "Primary website path",
        "value": "/pages/plan-your-event",
        "notes": "New Shopify Debut page"
      },
      {
        "setting": "Direct quote path",
        "value": "Existing Hulk Form",
        "notes": "Keep current flow for clients who know what they want"
      },
      {
        "setting": "Planner output",
        "value": "2 package options + menu reco + add-ons",
        "notes": "No full PDFs on website"
      },
      {
        "setting": "Proposal approach",
        "value": "Recommended dish first + alternative selections",
        "notes": "Keep client flexibility without overwhelming upfront"
      },
      {
        "setting": "VAT",
        "value": "12%",
        "notes": "Rates exclusive unless otherwise stated"
      },
      {
        "setting": "Service Charge",
        "value": "5%",
        "notes": "Rates exclusive unless otherwise stated"
      },
      {
        "setting": "Full Service Standard Duration",
        "value": "4 hours",
        "notes": "Excluding ingress/egress"
      },
      {
        "setting": "Rustic Stations Duration",
        "value": "3-4 hours or until supplies consumed",
        "notes": "Excluding ingress/egress"
      },
      {
        "setting": "Location Logic",
        "value": "Use Location_Rules as pre-qualification before package scoring",
        "notes": "Added for planner v1"
      }
    ],
    "Planner_Flow": [
      {
        "step": 1,
        "clientSees": "I already know what I need / Help me choose",
        "backendLogic": "Route choice",
        "output": "Direct Hulk Form OR Event Planner"
      },
      {
        "step": 2,
        "clientSees": "What type of event are you planning?",
        "backendLogic": "Event_Types + Package_Scoring",
        "output": "Initial service route"
      },
      {
        "step": 3,
        "clientSees": "Where is your event?",
        "backendLogic": "Venue/mobilization review later",
        "output": "Location tag / manual review flag"
      },
      {
        "step": 4,
        "clientSees": "How many guests?",
        "backendLogic": "Minimum pax + pricing matrix",
        "output": "Eligible packages"
      },
      {
        "step": 5,
        "clientSees": "Investment range",
        "backendLogic": "Budget_Compatibility",
        "output": "Excellent / Good / Stretch / Special Review"
      },
      {
        "step": 6,
        "clientSees": "Assistant Recommendation",
        "backendLogic": "Package scores + dish reco + add-ons",
        "output": "Best Fit + Alternative"
      },
      {
        "step": 7,
        "clientSees": "Continue to Formal Proposal",
        "backendLogic": "Hulk_Form_Mapping",
        "output": "Prefilled or hidden fields in Hulk"
      }
    ],
    "Recommendation_Rules": [
      {
        "ruleID": "RULE_EVENT_THEME",
        "inputTrigger": "Event type selected",
        "logic": "Use one of the four master event themes only",
        "output": "Route to Package_Scoring",
        "manualReviewFlag": "No"
      },
      {
        "ruleID": "RULE_SCORE_1",
        "inputTrigger": "Recommended Default",
        "logic": "Show first under Best Fit",
        "output": "Primary recommendation",
        "manualReviewFlag": "No"
      },
      {
        "ruleID": "RULE_SCORE_2",
        "inputTrigger": "Alternative",
        "logic": "Show after Best Fit under Alternatives",
        "output": "Alternative recommendation",
        "manualReviewFlag": "No"
      },
      {
        "ruleID": "RULE_BLANK",
        "inputTrigger": "Package or dish score is blank",
        "logic": "Do not show to client",
        "output": "Hidden",
        "manualReviewFlag": "No"
      },
      {
        "ruleID": "RULE_KIDDIE",
        "inputTrigger": "Birthdays & Social + children/kids mentioned",
        "logic": "Recommend Kiddie Buffet add-on if 20 kids+",
        "output": "Add-on suggestion",
        "manualReviewFlag": "Maybe"
      },
      {
        "ruleID": "RULE_WEDDING",
        "inputTrigger": "Weddings selected",
        "logic": "Lead with Signature / Rustic B; do not say full wedding package",
        "output": "Wedding-friendly catering options",
        "manualReviewFlag": "No"
      },
      {
        "ruleID": "RULE_COCKTAIL",
        "inputTrigger": "Cocktail & Networking selected",
        "logic": "Prioritize Rustic Cocktails and Signature Graze",
        "output": "Station-style recommendation",
        "manualReviewFlag": "No"
      },
      {
        "ruleID": "RULE_CORP_VOLUME",
        "inputTrigger": "Corporate + very large pax or low budget",
        "logic": "Flag for custom review",
        "output": "Manual commercial review",
        "manualReviewFlag": "Yes"
      },
      {
        "ruleID": "RULE_DECEMBER",
        "inputTrigger": "December event",
        "logic": "Apply December minimums from Package_Rules",
        "output": "Eligibility filter",
        "manualReviewFlag": "Maybe"
      },
      {
        "ruleID": "RULE_BELOW_MIN",
        "inputTrigger": "Pax below package minimum",
        "logic": "Suggest Party Trays if within delivery area or ask to increase pax",
        "output": "Do not force full catering quote",
        "manualReviewFlag": "Maybe"
      },
      {
        "ruleID": "RULE_MENU_OUTPUT",
        "inputTrigger": "Package selected",
        "logic": "Filter Menu_Scoring by selected package: 1 = Best Fit, 2 = Alternatives",
        "output": "Curated menu recommendation",
        "manualReviewFlag": "No"
      }
    ],
    "Addon_Event_Theme_Map": [
      {
        "addOnID": "ADD_KIDDIE",
        "addOnName": "Kiddie Buffet",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": null,
        "corporateEvents": null,
        "cocktailNetworkingEvents": null,
        "notes": "Minimum 20 kids"
      },
      {
        "addOnID": "ADD_MINI_GRAZE",
        "addOnName": "Mini Graze",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": null,
        "notes": "Good general upgrade"
      },
      {
        "addOnID": "ADD_SOUP",
        "addOnName": "Soup Service",
        "birthdaysSocialCelebrations": null,
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": null,
        "notes": "Best for full meal events"
      },
      {
        "addOnID": "ADD_HAM",
        "addOnName": "Ham & Pan de Sal Station",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": null,
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": null,
        "notes": "Good holiday/social/corporate add-on"
      },
      {
        "addOnID": "ADD_PORK_BOULANGERE",
        "addOnName": "Pork Boulangere Carving Station",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": null,
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": "Yes",
        "notes": "Good for stations"
      },
      {
        "addOnID": "ADD_ROAST_BEEF",
        "addOnName": "Classic U.S. Roast Beef Carving Station",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": null,
        "notes": "Premium full meal add-on"
      },
      {
        "addOnID": "ADD_PRIME_RIB",
        "addOnName": "U.S. Prime Rib Roast",
        "birthdaysSocialCelebrations": null,
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": null,
        "notes": "Manual quote"
      },
      {
        "addOnID": "ADD_FOIE_GRAS",
        "addOnName": "On-the-Spot Foie Gras Station",
        "birthdaysSocialCelebrations": null,
        "weddings": "Yes",
        "corporateEvents": null,
        "cocktailNetworkingEvents": "Yes",
        "notes": "Venue must allow open flame"
      },
      {
        "addOnID": "ADD_COFFEE_FULL",
        "addOnName": "Freshly Brewed Arabica Coffee",
        "birthdaysSocialCelebrations": null,
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": null,
        "notes": "Full service coffee"
      },
      {
        "addOnID": "ADD_COFFEE_STATION",
        "addOnName": "Freshly Brewed Arabica Coffee",
        "birthdaysSocialCelebrations": null,
        "weddings": null,
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": "Yes",
        "notes": "Rustic station coffee"
      },
      {
        "addOnID": "ADD_BEV_TUB",
        "addOnName": "Natalia's Beverage Tub",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": "Yes",
        "notes": "General beverage upgrade"
      },
      {
        "addOnID": "ADD_BEER_TUB",
        "addOnName": "Natalia's Beer Tub",
        "birthdaysSocialCelebrations": null,
        "weddings": null,
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": "Yes",
        "notes": "Casual corporate/networking"
      },
      {
        "addOnID": "ADD_PIMMS",
        "addOnName": "Natalia's Pimm's Cup",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": "Yes",
        "corporateEvents": null,
        "cocktailNetworkingEvents": "Yes",
        "notes": "Signature drink"
      },
      {
        "addOnID": "ADD_WINE",
        "addOnName": "Wine Service",
        "birthdaysSocialCelebrations": null,
        "weddings": "Yes",
        "corporateEvents": "Yes",
        "cocktailNetworkingEvents": "Yes",
        "notes": "Minimum bottles/glasses apply"
      },
      {
        "addOnID": "ADD_COCKTAIL_TABLE",
        "addOnName": "Cocktail Tables with Rustic Centerpiece",
        "birthdaysSocialCelebrations": null,
        "weddings": "Yes",
        "corporateEvents": null,
        "cocktailNetworkingEvents": "Yes",
        "notes": "For mingling setups"
      },
      {
        "addOnID": "ADD_RUSTIC_DINING",
        "addOnName": "Rustic Dining Set-up Upgrade",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": "Yes",
        "corporateEvents": null,
        "cocktailNetworkingEvents": null,
        "notes": "For intimate/prettier dining"
      },
      {
        "addOnID": "ADD_LECHON_SERVICE",
        "addOnName": "Lechon Service",
        "birthdaysSocialCelebrations": "Yes",
        "weddings": null,
        "corporateEvents": null,
        "cocktailNetworkingEvents": null,
        "notes": "Max 2 lechon"
      }
    ],
    "Package_Menus_Normalized": [
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Slider",
        "rule": "Included",
        "menuID": "MENU_CHEESEBURGER_SLIDERS_WITH_BACON_CHIPS",
        "menuItem": "Cheeseburger Sliders with Bacon & Chips",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Recommended for kiddie parties"
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Main Entrees",
        "rule": "All included",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Main Entrees",
        "rule": "All included",
        "menuID": "MENU_AMERICAN_STYLE_PORK_BBQ_RIBS",
        "menuItem": "American Style Pork BBQ Ribs",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Main Entrees",
        "rule": "All included",
        "menuID": "MENU_CHICKEN_TENDERS_WITH_GLAZED_DOUGHNUT_POPPERS",
        "menuItem": "Chicken Tenders with Glazed Doughnut Poppers",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO",
        "menuItem": "Homemade Pesto",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Rice",
        "rule": "Included",
        "menuID": "MENU_STEAMED_RICE",
        "menuItem": "Steamed Rice",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Dessert",
        "rule": "Included",
        "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
        "menuItem": "Salted Gooey Brownie Tart",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Refreshments",
        "rule": "Included",
        "menuID": "MENU_PURIFIED_DRINKING_WATER",
        "menuItem": "Purified Drinking Water",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_A",
        "packageName": "Rustic Menu A",
        "category": "Refreshments",
        "rule": "Included",
        "menuID": "MENU_ICED_TEA_UNTIL_SUPPLIES_LAST",
        "menuItem": "Iced Tea until supplies last",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_RUSTIC_CAESAR_SALAD",
        "menuItem": "Rustic Caesar Salad",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_SUMMER_SALAD",
        "menuItem": "Summer Salad",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_GREEK_SALAD",
        "menuItem": "Greek Salad",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_ASIAN_SOBA_SLAW_SALAD",
        "menuItem": "Asian Soba Slaw Salad",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_KEBAB_WITH_TZATZIKI_DIP",
        "menuItem": "Chicken Kebab with Tzatziki Dip",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
        "menuItem": "Traditional Roast Chicken",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_TERIYAKI",
        "menuItem": "Chicken Teriyaki",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
        "menuItem": "Jamaican Jerk Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_INASAL",
        "menuItem": "Chicken Inasal",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
        "menuItem": "Creamy Herb Garlic Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Seafood",
        "rule": "Choose 1",
        "menuID": "MENU_SEARED_NORWEGIAN_SALMON_WITH_MUSHROOM_CREAM_SAUCE",
        "menuItem": "Seared Norwegian Salmon with Mushroom Cream Sauce",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Seafood",
        "rule": "Choose 1",
        "menuID": "MENU_SHRIMP_CHORIZO_AL_AJILLO",
        "menuItem": "Shrimp & Chorizo Al Ajillo",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_CLASSIC_U_S_ROAST_BEEF",
        "menuItem": "Classic U.S. Roast Beef",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Signature Roast",
        "rule": "Included",
        "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY_WITH_FENNEL_ROASTED_VEGETABLES_",
        "menuItem": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO",
        "menuItem": "Homemade Pesto",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_VANILLA_CR_ME_BRULEE_POTS",
        "menuItem": "Vanilla Crème Brulee Pots",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_TIRAMISU",
        "menuItem": "Tiramisu",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_LUXE_BELGIAN_CHOCOLATE_MOUSSE",
        "menuItem": "Luxe Belgian Chocolate Mousse",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_RUSTIC_B",
        "packageName": "Rustic Menu B",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
        "menuItem": "Salted Gooey Brownie Tart",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_SPANISH_MEATBALLS",
        "menuItem": "Spanish Meatballs",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS_WITH_TZATZIKI_DIP",
        "menuItem": "Mini Chicken Kebab Skewers with Tzatziki Dip",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_MINI_CHICKEN_INASAL_SKEWERS",
        "menuItem": "Mini Chicken Inasal Skewers",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_EGG_SALAD_CANAPE",
        "menuItem": "Egg Salad Canape",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_CHICKEN_SALAD_SLIDER",
        "menuItem": "Chicken Salad Slider",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_ROAST_BEEF_CROSTINI",
        "menuItem": "Roast Beef Crostini",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
        "menuItem": "Brie & Berry Jam Crostini",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_CAPRESE_CROSTINI",
        "menuItem": "Caprese Crostini",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_TUNA_TARTLET",
        "menuItem": "Tuna Tartlet",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_SMOKED_SALMON_MOUSSE_TARTLET",
        "menuItem": "Smoked Salmon Mousse Tartlet",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_DUCK_CONFIT_TARTLET",
        "menuItem": "Duck Confit Tartlet",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_DUCK_CONFIT_TARTLET_FOIE_GRAS",
        "menuItem": "Duck Confit Tartlet & Foie Gras",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_RUSTIC_CAESAR_SALAD",
        "menuItem": "Rustic Caesar Salad",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_SUMMER_SALAD",
        "menuItem": "Summer Salad",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_GREEK_SALAD",
        "menuItem": "Greek Salad",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_ASIAN_SOBA_SLAW_SALAD",
        "menuItem": "Asian Soba Slaw Salad",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_KEBAB_WITH_TZATZIKI_DIP",
        "menuItem": "Chicken Kebab with Tzatziki Dip",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
        "menuItem": "Traditional Roast Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_TERIYAKI",
        "menuItem": "Chicken Teriyaki",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
        "menuItem": "Jamaican Jerk Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_INASAL",
        "menuItem": "Chicken Inasal",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
        "menuItem": "Creamy Herb Garlic Chicken",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Seafood",
        "rule": "Choose 1",
        "menuID": "MENU_SEARED_NORWEGIAN_SALMON_WITH_MUSHROOM_CREAM_SAUCE",
        "menuItem": "Seared Norwegian Salmon with Mushroom Cream Sauce",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Seafood",
        "rule": "Choose 1",
        "menuID": "MENU_SHRIMP_CHORIZO_AL_AJILLO",
        "menuItem": "Shrimp & Chorizo Al Ajillo",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO",
        "menuItem": "Homemade Pesto",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_CLASSIC_U_S_ROAST_BEEF",
        "menuItem": "Classic U.S. Roast Beef",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Signature Roast",
        "rule": "Included",
        "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY_WITH_FENNEL_ROASTED_VEGETABLES_",
        "menuItem": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_VANILLA_CR_ME_BRULEE_POTS",
        "menuItem": "Vanilla Crème Brulee Pots",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_TIRAMISU",
        "menuItem": "Tiramisu",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_LUXE_BELGIAN_CHOCOLATE_MOUSSE",
        "menuItem": "Luxe Belgian Chocolate Mousse",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_SIGNATURE",
        "packageName": "Natalia's Signature",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
        "menuItem": "Salted Gooey Brownie Tart",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Charcuterie",
        "rule": "Included",
        "menuID": "MENU_2_KINDS_OF_ARTISANAL_CHEESE",
        "menuItem": "2 kinds of Artisanal Cheese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Charcuterie",
        "rule": "Included",
        "menuID": "MENU_2_PREMIUM_CHARCUTERIE_CUTS",
        "menuItem": "2 Premium Charcuterie Cuts",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Charcuterie",
        "rule": "Included",
        "menuID": "MENU_FRESH_BERRIES",
        "menuItem": "Fresh Berries",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Welcome Drink",
        "rule": "Included",
        "menuID": "MENU_1_ROUND_TROPICAL_SUNSHINE_FRUIT_JUICE",
        "menuItem": "1 Round Tropical Sunshine Fruit Juice",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_SPANISH_MEATBALLS",
        "menuItem": "Spanish Meatballs",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS",
        "menuItem": "Mini Chicken Kebab Skewers",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_MINI_CHICKEN_INASAL_SKEWERS",
        "menuItem": "Mini Chicken Inasal Skewers",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_EGG_SALAD_CANAPE",
        "menuItem": "Egg Salad Canape",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_CHICKEN_SALAD_SLIDER",
        "menuItem": "Chicken Salad Slider",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_ROAST_BEEF_CROSTINI",
        "menuItem": "Roast Beef Crostini",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
        "menuItem": "Brie & Berry Jam Crostini",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_CAPRESE_CROSTINI",
        "menuItem": "Caprese Crostini",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_TUNA_TARTLET",
        "menuItem": "Tuna Tartlet",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Appetizers",
        "rule": "Choose 2",
        "menuID": "MENU_PREMIUM_TARTLETS",
        "menuItem": "premium tartlets",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Soup",
        "rule": "Choose 1",
        "menuID": "MENU_ROASTED_PUMPKIN_SOUP",
        "menuItem": "Roasted Pumpkin Soup",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Soup",
        "rule": "Choose 1",
        "menuID": "MENU_POTATO_LEEK_SOUP",
        "menuItem": "Potato & Leek Soup",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Soup",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_SOUP",
        "menuItem": "Mushroom Soup",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Soup",
        "rule": "Choose 1",
        "menuID": "MENU_TOMATO_SOUP",
        "menuItem": "Tomato Soup",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_RUSTIC_CAESAR_SALAD",
        "menuItem": "Rustic Caesar Salad",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_SUMMER_SALAD",
        "menuItem": "Summer Salad",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_GREEK_SALAD",
        "menuItem": "Greek Salad",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Salad",
        "rule": "Choose 1",
        "menuID": "MENU_ASIAN_SOBA_SLAW_SALAD",
        "menuItem": "Asian Soba Slaw Salad",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_KEBAB_WITH_TZATZIKI_DIP",
        "menuItem": "Chicken Kebab with Tzatziki Dip",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
        "menuItem": "Traditional Roast Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_TERIYAKI",
        "menuItem": "Chicken Teriyaki",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
        "menuItem": "Jamaican Jerk Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_INASAL",
        "menuItem": "Chicken Inasal",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
        "menuItem": "Creamy Herb Garlic Chicken",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO",
        "menuItem": "Homemade Pesto",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Main Entrees",
        "rule": "All included",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Main Entrees",
        "rule": "All included",
        "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY",
        "menuItem": "6-hr Slow Roasted Pork Belly",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Main Entrees",
        "rule": "All included",
        "menuID": "MENU_THREE_CHEESE_BAKED_PRAWNS",
        "menuItem": "Three Cheese Baked Prawns",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Rustic Tartlets",
        "rule": "Included",
        "menuID": "MENU_FRUIT_TARTLET",
        "menuItem": "Fruit Tartlet",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "FC_FEAST",
        "packageName": "Natalia's Rustic Feast",
        "category": "Rustic Tartlets",
        "rule": "Included",
        "menuID": "MENU_CHOCOLATE_MOUSSE_TARTLET_WITH_CARDAMOM",
        "menuItem": "Chocolate Mousse Tartlet with Cardamom",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Salad",
        "rule": "Included",
        "menuID": "MENU_MESCLUN_GREENS_WITH_BALSAMIC_DRESSING",
        "menuItem": "Mesclun Greens with Balsamic Dressing",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_BRAISED_BEEF_SHORT_RIBS",
        "menuItem": "Braised Beef Short Ribs",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
        "menuItem": "Traditional Roast Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_TERIYAKI",
        "menuItem": "Chicken Teriyaki",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
        "menuItem": "Jamaican Jerk Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_INASAL",
        "menuItem": "Chicken Inasal",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CLASSIC_CHICKEN_BBQ",
        "menuItem": "Classic Chicken BBQ",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
        "menuItem": "Creamy Herb Garlic Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Fish",
        "rule": "Included",
        "menuID": "MENU_GOLDEN_CREAM_DORY_FILLET_WITH_TARTAR_SAUCE",
        "menuItem": "Golden Cream Dory Fillet with Tartar Sauce",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO",
        "menuItem": "Homemade Pesto",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Sides",
        "rule": "Included",
        "menuID": "MENU_STEAMED_RICE",
        "menuItem": "Steamed Rice",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Sides",
        "rule": "Included",
        "menuID": "MENU_HOMEMADE_MASHED_POTATOES",
        "menuItem": "Homemade Mashed Potatoes",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_LECHE_FLAN",
        "menuItem": "Leche Flan",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Peach & Mango Parfait recommended indoors only"
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_CATHEDRAL_WINDOW_JELLY",
        "menuItem": "Creamy Cathedral Window Jelly",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": "Peach & Mango Parfait recommended indoors only"
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_DOUBLE_CHOCOLATE_BELGIAN_BROWNIE_BITES",
        "menuItem": "Double Chocolate Belgian Brownie Bites",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": "Peach & Mango Parfait recommended indoors only"
      },
      {
        "packageID": "ST_A",
        "packageName": "Standard Menu A",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_PEACH_MANGO_PARFAIT",
        "menuItem": "Peach & Mango Parfait",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": "Peach & Mango Parfait recommended indoors only"
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Salad",
        "rule": "Included",
        "menuID": "MENU_MESCLUN_GREENS_WITH_BALSAMIC_DRESSING",
        "menuItem": "Mesclun Greens with Balsamic Dressing",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_BRAISED_BEEF_SHORT_RIBS",
        "menuItem": "Braised Beef Short Ribs",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Beef",
        "rule": "Choose 1",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_TRADITIONAL_ROAST_CHICKEN",
        "menuItem": "Traditional Roast Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_TERIYAKI",
        "menuItem": "Chicken Teriyaki",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_JAMAICAN_JERK_CHICKEN",
        "menuItem": "Jamaican Jerk Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CHICKEN_INASAL",
        "menuItem": "Chicken Inasal",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CLASSIC_CHICKEN_BBQ",
        "menuItem": "Classic Chicken BBQ",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Chicken",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_HERB_GARLIC_CHICKEN",
        "menuItem": "Creamy Herb Garlic Chicken",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Fish",
        "rule": "Included",
        "menuID": "MENU_GOLDEN_CREAM_DORY_FILLET_WITH_TARTAR_SAUCE",
        "menuItem": "Golden Cream Dory Fillet with Tartar Sauce",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO",
        "menuItem": "Homemade Pesto",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Signature Roast",
        "rule": "Included",
        "menuID": "MENU_6_HR_SLOW_ROASTED_PORK_BELLY_WITH_FENNEL_ROASTED_VEGETABLES_",
        "menuItem": "6-hr Slow Roasted Pork Belly with Fennel, Roasted Vegetables & Pork Jus",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_LECHE_FLAN",
        "menuItem": "Leche Flan",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMY_CATHEDRAL_WINDOW_JELLY",
        "menuItem": "Creamy Cathedral Window Jelly",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_DOUBLE_CHOCOLATE_BELGIAN_BROWNIE_BITES",
        "menuItem": "Double Chocolate Belgian Brownie Bites",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "ST_B",
        "packageName": "Standard Menu B",
        "category": "Dessert",
        "rule": "Choose 1",
        "menuID": "MENU_PEACH_MANGO_PARFAIT",
        "menuItem": "Peach & Mango Parfait",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuID": "MENU_CROISSANT_PETITE_PLATTER",
        "menuItem": "Croissant Petite Platter",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuID": "MENU_CHICKEN_TENDERS_GLAZED_DOUGHNUT_POPPERS",
        "menuItem": "Chicken Tenders & Glazed Doughnut Poppers",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuID": "MENU_MINI_HASH_BROWNS",
        "menuItem": "Mini Hash Browns",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuID": "MENU_TROPICAL_FRUIT_KEBAB",
        "menuItem": "Tropical Fruit Kebab",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Base Inclusions",
        "rule": "Included",
        "menuID": "MENU_BOTTLED_WATER",
        "menuItem": "Bottled Water",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Slider or Crostini",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_CHEESEBURGER_SLIDERS",
        "menuItem": "Cheeseburger Sliders",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Slider or Crostini",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_CHUNKY_CHICKEN_EGG_SALAD_SLIDERS",
        "menuItem": "Chunky Chicken & Egg Salad Sliders",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Slider or Crostini",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_ROAST_BEEF_CROSTINI",
        "menuItem": "Roast Beef Crostini",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Slider or Crostini",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
        "menuItem": "Brie & Berry Jam Crostini",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO_PASTA",
        "menuItem": "Homemade Pesto Pasta",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
        "menuItem": "Salted Gooey Brownie Tart",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_VANILLA_CREME_BRULEE_POTS",
        "menuItem": "Vanilla Creme Brulee Pots",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_TIRAMISU",
        "menuItem": "Tiramisu",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_BITES",
        "packageName": "Rustic Bites",
        "category": "Dessert",
        "rule": "30-50 choose 1; 100 choose up to 2",
        "menuID": "MENU_LUXE_CHOCOLATE_MOUSSE",
        "menuItem": "Luxe Chocolate Mousse",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_SPANISH_MEATBALLS",
        "menuItem": "Spanish Meatballs",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS",
        "menuItem": "Mini Chicken Kebab Skewers",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_MINI_CHICKEN_INASAL_SKEWERS",
        "menuItem": "Mini Chicken Inasal Skewers",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_EGG_SALAD_CANAPE",
        "menuItem": "Egg Salad Canape",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_CHICKEN_SALAD_SLIDER",
        "menuItem": "Chicken Salad Slider",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_ROAST_BEEF_CROSTINI",
        "menuItem": "Roast Beef Crostini",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_BRIE_BERRY_JAM_CROSTINI",
        "menuItem": "Brie & Berry Jam Crostini",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_CAPRESE_CROSTINI",
        "menuItem": "Caprese Crostini",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_TUNA_TARTLET",
        "menuItem": "Tuna Tartlet",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_SMOKED_SALMON_MOUSSE_TARTLET",
        "menuItem": "Smoked Salmon Mousse Tartlet",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_DUCK_CONFIT_TARTLET",
        "menuItem": "Duck Confit Tartlet",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Canape & Crostini",
        "rule": "Choose 4",
        "menuID": "MENU_DUCK_CONFIT_TARTLET_FOIE_GRAS",
        "menuItem": "Duck Confit Tartlet & Foie Gras",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P20/+P70/+P140 per head for premium upgrades",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Bites",
        "rule": "Both included",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Bites",
        "rule": "Both included",
        "menuID": "MENU_PORK_BOULANGERE",
        "menuItem": "Pork Boulangere",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO_PASTA",
        "menuItem": "Homemade Pesto Pasta",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Dessert",
        "rule": "30/50 choose 1; 100 choose 1-2",
        "menuID": "MENU_SALTED_GOOEY_BROWNIE_TART",
        "menuItem": "Salted Gooey Brownie Tart",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Dessert",
        "rule": "30/50 choose 1; 100 choose 1-2",
        "menuID": "MENU_VANILLA_CREME_BRULEE_POTS",
        "menuItem": "Vanilla Creme Brulee Pots",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Dessert",
        "rule": "30/50 choose 1; 100 choose 1-2",
        "menuID": "MENU_TIRAMISU",
        "menuItem": "Tiramisu",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Refreshments",
        "rule": "Included",
        "menuID": "MENU_SPARKLING_WATER_SODA",
        "menuItem": "Sparkling Water & Soda",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Refreshments",
        "rule": "Included",
        "menuID": "MENU_STILL_WATER",
        "menuItem": "Still Water",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_COCKTAILS",
        "packageName": "Natalia's Rustic Cocktails",
        "category": "Refreshments",
        "rule": "Included",
        "menuID": "MENU_CITRUS_INFUSED_WATER",
        "menuItem": "Citrus-Infused Water",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuID": "MENU_CAPRESE",
        "menuItem": "Caprese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuID": "MENU_4_ARTISANAL_CHEESES",
        "menuItem": "4 Artisanal Cheeses",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuID": "MENU_3_PREMIUM_CHARCUTERIE_CUTS",
        "menuItem": "3 Premium Charcuterie Cuts",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_TROPICAL_FRUIT_KEBAB",
        "menuItem": "Tropical Fruit Kebab",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_GRAPES_BERRIES",
        "menuItem": "Grapes & Berries",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_OLIVES",
        "menuItem": "Olives",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_CRACKERS",
        "menuItem": "Crackers",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Bites",
        "rule": "Included",
        "menuID": "MENU_EGG_SALAD_CANAPE",
        "menuItem": "Egg Salad Canape",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Bites",
        "rule": "Included",
        "menuID": "MENU_ROAST_BEEF_CROSTINI_WITH_CHIMICHURRI",
        "menuItem": "Roast Beef Crostini with Chimichurri",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Bites",
        "rule": "Included",
        "menuID": "MENU_CHEESEBURGER_SLIDERS",
        "menuItem": "Cheeseburger Sliders",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Bites",
        "rule": "Included",
        "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS_WITH_TZATZIKI_DIP",
        "menuItem": "Mini Chicken Kebab Skewers with Tzatziki Dip",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_CLASSIC_GRAZE",
        "packageName": "Classic Graze",
        "category": "Sweet Treat",
        "rule": "Included",
        "menuID": "MENU_BELGIAN_CHOCOLATE_BROWNIE_BITES",
        "menuItem": "Belgian Chocolate Brownie Bites",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuID": "MENU_CAPRESE",
        "menuItem": "Caprese",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuID": "MENU_4_ARTISANAL_CHEESES",
        "menuItem": "4 Artisanal Cheeses",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Cheese & Charcuterie",
        "rule": "Included",
        "menuID": "MENU_3_PREMIUM_CHARCUTERIE_CUTS",
        "menuItem": "3 Premium Charcuterie Cuts",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_TROPICAL_FRUIT_KEBAB",
        "menuItem": "Tropical Fruit Kebab",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_GRAPES_BERRIES",
        "menuItem": "Grapes & Berries",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_OLIVES",
        "menuItem": "Olives",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Accoutrements",
        "rule": "Included",
        "menuID": "MENU_CRACKERS",
        "menuItem": "Crackers",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Bites",
        "rule": "All included",
        "menuID": "MENU_EGG_SALAD_CANAPE",
        "menuItem": "Egg Salad Canape",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Bites",
        "rule": "All included",
        "menuID": "MENU_ROAST_BEEF_CROSTINI_WITH_CHIMICHURRI",
        "menuItem": "Roast Beef Crostini with Chimichurri",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Bites",
        "rule": "All included",
        "menuID": "MENU_MINI_CHICKEN_KEBAB_SKEWERS",
        "menuItem": "Mini Chicken Kebab Skewers",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Bites",
        "rule": "All included",
        "menuID": "MENU_SIGNATURE_BEEF_SALPICAO",
        "menuItem": "Signature Beef Salpicao",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MIGHTY_MEATY_BOLOGNESE",
        "menuItem": "Mighty Meaty Bolognese",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_CREAMED_FETTUCCINE",
        "menuItem": "Creamed Fettuccine",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_HOMEMADE_PESTO_PASTA",
        "menuItem": "Homemade Pesto Pasta",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_MUSHROOM_PASTA_RIGATONI",
        "menuItem": "Mushroom Pasta Rigatoni",
        "available": "Yes",
        "recoScore": null,
        "recoType": null,
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Pasta",
        "rule": "Choose 1",
        "menuID": "MENU_TRUFFLE_CREAM_FETTUCCINE",
        "menuItem": "Truffle Cream Fettuccine",
        "available": "Yes",
        "recoScore": 2,
        "recoType": "Alternative",
        "upgradePrice": "+P30/head for Truffle or Mushroom Truffle",
        "notes": null
      },
      {
        "packageID": "RS_SIGNATURE_GRAZE",
        "packageName": "Signature Graze",
        "category": "Sweet Treat",
        "rule": "Included",
        "menuID": "MENU_BELGIAN_DOUBLE_CHOCOLATE_BROWNIE_BITES",
        "menuItem": "Belgian Double Chocolate Brownie Bites",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": null
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_PETITE_CROISSANT_PLATTER",
        "menuItem": "Petite Croissant Platter",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_EGG_SALAD_CANAPE",
        "menuItem": "Egg Salad Canape",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_DOUBLE_CHOCOLATE_BROWNIE_BITES",
        "menuItem": "Double Chocolate Brownie Bites",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_SPANISH_MEATBALLS",
        "menuItem": "Spanish Meatballs",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_MINI_CHICKEN_KEBAB",
        "menuItem": "Mini Chicken Kebab",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_MINI_CHEESE_FRUIT_SPREAD",
        "menuItem": "Mini Cheese & Fruit Spread",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_4_ARTISANAL_CHEESES",
        "menuItem": "4 Artisanal Cheeses",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_1_PREMIUM_CHARCUTERIE_CUT",
        "menuItem": "1 Premium Charcuterie Cut",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_FRUITS_BERRIES",
        "menuItem": "Fruits & Berries",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      },
      {
        "packageID": "RS_LITE",
        "packageName": "Natalia's Rustic Lite",
        "category": "All Selections",
        "rule": "All included",
        "menuID": "MENU_CITRUS_INFUSED_WATER",
        "menuItem": "Citrus-Infused Water",
        "available": "Yes",
        "recoScore": 1,
        "recoType": "Best Fit",
        "upgradePrice": null,
        "notes": "Minimum 100 guests"
      }
    ],
    "Location_Rules": [
      {
        "locationID": "LOC_METRO_MANILA",
        "locationOption": "Metro Manila",
        "serviceStatus": "Serviced",
        "plannerAction": "Allow instant recommendation",
        "eligiblePackageLogic": "Use standard package scoring",
        "minimumPreQualification": "Apply regular package minimums; December minimums still apply",
        "manualReviewFlag": "No",
        "clientFacingNote": "We service Metro Manila. Final quotation may include mobilization depending on venue."
      },
      {
        "locationID": "LOC_CAVITE",
        "locationOption": "Cavite",
        "serviceStatus": "Serviced",
        "plannerAction": "Allow instant recommendation",
        "eligiblePackageLogic": "Use standard package scoring",
        "minimumPreQualification": "Apply regular package minimums; December minimums still apply",
        "manualReviewFlag": "No",
        "clientFacingNote": "We service Cavite, subject to schedule and mobilization."
      },
      {
        "locationID": "LOC_TAGAYTAY",
        "locationOption": "Tagaytay",
        "serviceStatus": "Serviced",
        "plannerAction": "Allow instant recommendation",
        "eligiblePackageLogic": "Use Cavite / out-of-base mobilization review",
        "minimumPreQualification": "Apply regular package minimums unless otherwise reviewed",
        "manualReviewFlag": "Maybe",
        "clientFacingNote": "We cater Tagaytay events, subject to availability and mobilization."
      },
      {
        "locationID": "LOC_LAGUNA",
        "locationOption": "Laguna",
        "serviceStatus": "Select Areas",
        "plannerAction": "Allow recommendation but flag review",
        "eligiblePackageLogic": "Use standard package scoring",
        "minimumPreQualification": "Check exact city and venue before final quote",
        "manualReviewFlag": "Maybe",
        "clientFacingNote": "We service select Laguna areas. Please share the exact venue for confirmation."
      },
      {
        "locationID": "LOC_BATANGAS",
        "locationOption": "Batangas",
        "serviceStatus": "Select Areas / Manual Review",
        "plannerAction": "Pre-qualify before package recommendation",
        "eligiblePackageLogic": "Rustic min 50; Standard min 70; final availability review required",
        "minimumPreQualification": "If pax below Batangas minimum, do not show instant package recommendation",
        "manualReviewFlag": "Yes",
        "clientFacingNote": "For Batangas, minimums and mobilization depend on exact location and package."
      },
      {
        "locationID": "LOC_OTHER",
        "locationOption": "Other / Outside Nearby Areas",
        "serviceStatus": "Manual Review",
        "plannerAction": "Do not auto-recommend; collect details",
        "eligiblePackageLogic": "No instant package scoring",
        "minimumPreQualification": "Ask for exact venue and event details",
        "manualReviewFlag": "Yes",
        "clientFacingNote": "Please share your exact location so our team can confirm if we can service the area."
      }
    ]
  }
}
;